/* Language pack: pt */
export const translationsPt = {
	resumeRecording: "Retomar",
	chatCallMissed: "Perdida",
	chatCallDeclined: "Recusada",
	chatAudioConference: "Conferência de áudio",
	chatVideoConference: "Videoconferência",

	IDCardImages: "Imagens de cartão de identificação",
	IT: "TI",
	Status: "Status",
	abbreviation: "Abreviação",
	aboutUsItems: "Itens Sobre nós",
	absent: "Ausente",
	accept: "Aceitar",
	actSendingDate: "Data de envio do ato",
	actionTimestamp: "Carimbo de data/hora da ação",
	actionType: "Tipo de ação",
	actions: "Ações",
	activateStep7_8_9: "Atribuição ao departamento de linhas de transmissão de energia ( 7, 8, 9 )",
	activateStep8: "Atribuição ao departamento geodésico ( 8 )",
	activatedProjects: "Projetos ativados",
	active: "Ativo",
	activeCarts: "Carrinhos ativos",
	activeClients: "Clientes ativos",
	activeCustomers: "Clientes ativos",
	activeProjectSteps: "Etapas ativas do projeto",
	activePromos: "Promoções ativas",
	activeSales: "Vendas ativas",
	activeSalesEvents: "Eventos de venda ativos",
	activeServices: "serviços ativos",
	activeSteps: "Etapas ativas",
	activeStreams: "Transmissões ativas",
	activeTasks: "Tarefas ativas",
	activeTime: "Tempo ativo",
	activity: "Atividade",
	actualHours: "Horas reais",
	adInterval: "Intervalo de anúncios",
	adIntervalOverride: "Regras de planejamento",
	adIntervalOverrideDesc: "Regras de planejamento",
	adIntervalOverrideValue: "Regras de planejamento",
	adPlaylist: "Lista de reprodução de anúncios",
	adPlaylists: "Playlists publicitárias",
	adTracks: "Faixas publicitárias",
	add: "Adicionar",
	addAttendance: "Adicionar Frequência",
	addFeature: "Adicionar funcionalidade",
	addFeatureLine: "Adicionar linha de funcionalidade",
	addFiles: "Adicionar mais arquivos",
	addMoreFiles: "Adicionar mais arquivos",
	addNew: "Adicionar novo",
	addPriceLine: "Adicionar linha de preço",
	addRule: "Adicionar regra",
	addToList: "Adicionar à lista",
	addVacationInterval: "Adicionar período de férias",
	added: "Adicionado",
	additionalDetails: "Detalhes adicionais",
	address: "Endereço",
	addressData: "Dados de endereço",
	advanceDeductions: "Descontos de adiantamento",
	advertisement: "Publicidade",
	age: "Idade",
	ageGroups: "Grupos etários",
	ago: "atrás",
	agreedProjects: "Projetos acordados",
	agreementAquipment: "Acordo sobre equipamentos",
	aiConversations: "Conversas",
	album: "Álbum",
	allArtists: "todos os artistas",
	allAudioTracks: "todas as faixas de áudio",
	allContentItems: "todos os itens de conteúdo",
	allFilesDeleted: "Todos os arquivos foram permanentemente deletados",
	allFilesWillBeDeleted: "Todos os arquivos serão excluídos permanentemente",
	allPlaylists: "todas as playlists",
	allRegisteredContacts: "todos os clientes registrados",
	allTickets: "Todos os tickets",
	amount: "Quantidade",
	analytics: "Analítica",
	answer: "Resposta",
	apartment: "Apartamento",
	apply: "Aplicar",
	appsMenu: "Menu de aplicativos",
	approved: "Aprovado",
	approvedInterval: "Intervalo aprovado",
	archive: "Arquivo",
	archived: "Arquivado",
	areYouSure: "Tem certeza?",
	areYouSureToDelete: "Tem certeza de que deseja excluir isso?",
	artist: "Artista",
	artistObject: "Objeto artístico",
	assignedTo: "Atribuído a",
	assignedToUser: "Atribuído a",
	assignmentToTheConstructionDepartment: "Atribuição ao departamento de construção",
	attach: "Anexar",
	attachFile: "Anexar arquivo",
	attachments: "Anexos",
	attendance: "Frequência",
	attendanceFlag: "Status de presença",
	attendanceRequiringAttention: "Funcionários que Precisam de Atenção",
	attendanceNoAttentionItems: "Nenhum funcionário precisa de atenção",
	attendanceMissingCheckIn: "Falta de entrada",
	attendanceMissingCheckOut: "Falta de saída",
	attendanceEarlyLeave: "Saída antecipada",
	attendanceEarlyMissings: "Saídas antecipadas",
	attendanceEarlyMissingHours: "Horas de saída antecipada",
	attendanceLateHours: "Horas de atraso",
	attendanceShowWorkedHours: "Mostrar horas trabalhadas",
	attendanceUnapprovedAbsence: "Ausência não aprovada",
	attendanceDeptAttendance: "Frequência por Departamento",
	attendanceDeviceHealth: "Saúde dos Dispositivos e Sincronização ao Vivo",
	attendanceLastSync: "Última sincronização",
	attendanceLiveFeed: "Feed de Frequência ao Vivo",
	attendanceNoRecentPunches: "Nenhuma marcação recente",
	attendanceManualEntryTag: "Manual",
	attendanceUnmappedPunch: "Não associado",
	attendancePendingItems: "pendente",
	flexCardTotal: "Cartões Flex",
	attendanceCards: "Cartões de presença",
	flexCardTotalSubtitle: "IDs Flex atribuídos ou ignorados",
	flexCardsAttached: "Vinculado",
	flexCardsAttachedSubtitle: "IDs exclusivos vinculados a usuários",
	flexCardsIgnored: "Ignorado",
	flexCardsIgnoredSubtitle: "Ignorado nas configurações de RH",
	flexCardsDuplicateAttached: "Vinculado duplicado",
	flexCardIds: "IDs de cartão",
	noDuplicateFlexCards: "Sem duplicatas",
	attendanceTrendPctOfEmployeesPresent: "% de funcionários presentes",
	yesterday: "Ontem",
	attendanceFilterThisWeek: "Esta Semana",
	attendanceFilterThisMonth: "Este Mês",
	attendanceFilterCustom: "Personalizado",
	attendanceSelectRange: "Selecionar período",
	attendanceCustomRangeCapped: "O período personalizado é limitado a 90 dias",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Presença de Hoje",
	attendanceTitleYesterday: "Presença de Ontem",
	attendanceTitleThisWeek: "Presença desta Semana",
	attendanceTitleThisMonth: "Presença deste Mês",
	attendanceTitleCustom: "Presença do Período Selecionado",
	attendanceTitleTodayKpis: "KPIs de Presença de Hoje",
	attendanceTitleYesterdayKpis: "KPIs de Presença de Ontem",
	attendanceTitleThisWeekKpis: "KPIs de Presença desta Semana",
	attendanceTitleThisMonthKpis: "KPIs de Presença deste Mês",
	attendanceTitleCustomKpis: "KPIs do Período Selecionado",
	attendanceTrendDays: "Tendência de Presença — Últimos {n} Dias",
	attendanceNotAttendedYet: "Ainda Não Compareceu",
	attendanceUpcomingAbsences: "Próximas Ausências",
	attendanceUpcomingAbsencesEmpty: "Nenhuma ausência próxima",
	attendanceUpcomingAbsencesTomorrow: "Amanhã",
	attendanceUpcomingAbsencesInDays: "Em {days} dias",
	attendanceExceptions: "Exceções de Presença",
	attendanceExceptionsMissingCheckIn: "Entradas Ausentes",
	attendanceExceptionsMissingCheckOut: "Saídas Ausentes",
	attendanceExceptionsEarlyLeaves: "Saídas Antecipadas",
	attendanceExceptionsUnapprovedAbsences: "Ausências Não Aprovadas",
	attendanceExceptionsDuplicatePunches: "Registros Duplicados",
	attendanceMonthlyKpis: "KPIs Mensais de Presença",
	attendanceKpiRate: "Taxa de Presença",
	attendanceKpiAvgArrival: "Chegada Média",
	attendanceKpiLateArrivals: "Atrasos",
	attendanceKpiAbsentDays: "Dias de Ausência",
	attendanceKpiOvertimeHours: "Horas Extras",
	attendanceLeaveBalanceOverview: "Resumo do Saldo de Férias",
	attendanceLeaveBalanceVacationRemaining: "Férias Restantes",
	attendanceLeaveBalanceSickUsed: "Licença Médica Utilizada",
	attendanceLeaveBalanceBusinessTrips: "Viagens de Negócios",
	attendanceLeaveBalancePendingRequests: "Solicitações Pendentes",
	attendanceLeaveBalanceCoverage: "{covered} de {total} funcionários",
	attendanceTopInsights: "Principais Insights de Presença",
	attendanceInsightNoData: "Ainda não há dados disponíveis",
	attendanceInsightHighestLateness: "{dept} tem a maior taxa de atraso esta semana ({delta})",
	attendanceInsightFullAttendanceToday: "{dept} tem 100% de presença",
	attendanceInsightTrendImproved: "A presença melhorou {pct}% em relação ao período anterior",
	attendanceInsightTrendDeclined: "A presença caiu {pct}% em relação ao período anterior",
	attendanceInsightApproachingOvertime: "{count} funcionários estão se aproximando do limite de horas extras",
	attendancePreviousWeek: "Semana Passada",
	attendanceCurrentWeek: "Esta Semana",
	attendanceAddInterval: "Adicionar intervalo",
	attendanceBreakLabel: "Pausa",
	attendanceCorrectionMode: "Modo de correção",
	attendanceCustomIntervals: "Intervalos personalizados",
	attendanceDashboard: "Painel de Frequência",
	attendanceReports: "Relatórios",
	attendanceCalendarTab: "Calendário",
	reports: "Relatórios",
	shiftCoverage: "Cobertura de turnos",
	previousPeriod: "Período anterior",
	nextPeriod: "Próximo período",
	failedToSave: "Não foi possível salvar o comentário de horas extras",
	expandForDailyDetail: "Expandir linha para detalhes diários",
	noDataForPeriod: "Sem dados para este período",
	attendanceHistory: "Histórico de presença",
	attendanceDayOffTab: "Folga",
	attendanceDayType: "Tipo de dia",
	attendanceDetectedIntervals: "Intervalos detectados",
	attendanceEditDay: "Editar dia",
	attendanceHrsTotal: "h no total",
	attendanceViewWeek: "Semana",
	attendanceViewMonth: "Mês",
	attendanceViewDay: "Dia",
	day: "Dia",
	attendanceOpenFrom: "Aberto desde {time}",
	attendanceFromStillActive: "Desde {time} → ainda ativo",
	attendanceTotalWorked: "Total trabalhado",
	attendanceMissingUncovered: "Ausente / não coberto",
	attendanceNoData: "Sem dados",
	attendanceNoDataForDay: "Sem dados de presença para este dia.",
	attendanceIntervalApprovedOk: "Aprovado / OK",
	attendanceIntervalEachRowInvalid: "Informe horário de início e fim válidos para cada intervalo",
	attendanceIntervalTimesInvalid: "Informe horário de início e fim válidos",
	attendanceIntervalsMode: "Intervalos",
	attendanceIntervalsReviewHint:
		"Revise o trabalhado real, férias/licenças e lacunas. Adicione abaixo intervalos manuais para marcar como aprovado, trabalho, remoto, baixa, férias, não remunerado ou outro.",
	attendanceLogSubtitle: "Entrada manual de frequência — trabalho, baixas, férias",
	attendanceLogTitle: "Registro de frequência",
	attendanceManualResolutionIntervals: "Intervalos de correção manual",
	attendanceMissingLabel: "Faltando",
	attendanceNoManualIntervalsYet: "Nenhum intervalo manual adicionado ainda",
	attendanceNoUncovered: "Nenhum intervalo não coberto detectado",
	attendanceOptionalNotePlaceholder: "Nota opcional…",
	attendancePtoLeaveSection: "Licença remunerada / licença",
	attendanceReport: "Relatório de Frequência",
	attendanceResolveInterval: "Resolver este intervalo",
	attendanceResyncTooltip: "Ressincronizar a presença deste funcionário",
	attendanceResyncSuccess: "Ressincronização de presença iniciada",
	attendanceResyncFailed: "Falha ao ressincronizar a presença",
	attendanceSavedSuccess: "Frequência salva com sucesso",
	attendanceStatusUpcoming: "Próximo",
	attendanceSelectEmployeePrompt: "Selecione um funcionário para ver a frequência",
	attendanceTrend: "Tendência de Presença",
	attendanceTrendPctPresent: "% Presentes",
	attendanceUncoveredMissing: "Não coberto / faltante",
	attendanceUnsavedChanges: "Alterações não salvas",
	attendanceWholeDayStatus: "Status do dia inteiro",
	shiftWorker: "Trabalhador por turnos",
	attendanceIgnoreMode: "Ignorar",
	attendanceIgnoreScopeWeekdays: "Dias da semana",
	attendanceIgnoreScopeDateRange: "Intervalo de datas",
	attendanceIgnoreScopeWeekdaysHint: "Aplica-se apenas aos dias da semana selecionados neste período.",
	attendanceIgnoreScopeDateRangeHint: "Aplica-se a todos os dias deste período.",
	attendanceIgnoreAppliesTo: "Aplica-se a",
	attendanceIgnoreLateArrival: "Chegada atrasada",
	attendanceIgnoreEarlyLeave: "Saída antecipada",
	attendanceIgnoreWindowStart: "Início da janela de tolerância",
	attendanceIgnoreWindowEnd: "Fim da janela de tolerância",
	attendanceIgnoreRulesList: "Regras de tolerância",
	attendanceIgnoreRulesEmpty: "Ainda não há regras de tolerância",
	attendanceIgnoreDaysOfWeekRequired: "Selecione pelo menos um dia",
	attendanceIgnoredLabel: "Ignorado",
	attendanceNoCardLabel: "Sem cartão",
	attendanceWork: "Trabalho",
	attendanceWorked: "Trabalhado",
	attendanceWorkedIntervals: "Intervalos trabalhados",
	attendanceMissingIntervals: "Intervalos em falta",
	attendanceStillInOffice: "Ainda no escritório",
	attendanceAddEvent: "Adicionar evento",
	attendanceAddAttendanceEvent: "Adicionar evento de presença",
	attendanceDeleteEventTitle: "Eliminar evento de presença?",
	attendanceDeleteEventText:
		"Isto remove apenas este evento de entrada/saída adicionado manualmente.",
	attendanceNoMissingIntervals: "Sem intervalos em falta para este dia",
	attendanceOfficeSince: "Desde {time}",
	attendanceLastOutAt: "Última saída {time}",
	attendanceEventSingular: "evento",
	attendanceEventPlural: "eventos",
	attendancePunchIn: "Entrada",
	attendancePunchOut: "Saída",
	solveThis: "Resolver",
	editSolvedStatus: "Editar estado resolvido",
	officeStatus: "Estado no escritório",
	outOfOffice: "Fora do escritório",
	noPunches: "Sem registos",
	lastActionWasCheckIn: "A última ação foi entrada",
	lastActionWasCheckOut: "A última ação foi saída",
	noCheckInYet: "Ainda sem entrada",
	manual: "Manual",
	resolved: "Resolvido",
	attendanceManualStatusApplyTicketTimeTo: "Aplicar o tempo do ticket a",
	attendanceManualStatusColumnAttendanceType: "Tipo de presença",
	attendanceManualStatusColumnTimeAction: "Ação de tempo",
	attendanceManualStatusMapsToType: "Corresponde ao tipo de presença",
	attendanceManualStatusTicketTimeAction: "Ação de tempo da automação do ticket",
	attendanceTicketTimePhraseAdd: "Adicionar tempo de {type}",
	attendanceTicketTimePhraseSubtract: "Subtrair tempo de {type}",
	attendanceTimeOpAdd: "Adicionar tempo do ticket",
	attendanceTimeOpNone: "Sem alteração no saldo de tempo",
	attendanceTimeOpSubtract: "Subtrair tempo do ticket",
	attendanceTypeOptionAbsent: "Ausente",
	attendanceTypeOptionBusinessTrip: "Viagem de negócios",
	attendanceTypeOptionHolidayNonWorking: "Feriado / não útil",
	attendanceTypeOptionJustifiedAbsence: "Falta justificada (excusada)",
	attendanceTypeOptionMaternity: "Licença-maternidade",
	attendanceTypeOptionPaidVacation: "Férias remuneradas",
	attendanceTypeOptionRemote: "Trabalho remoto",
	attendanceTypeOptionSickLeave: "Licença médica",
	attendanceTypeOptionUnjustifiedAbsence: "Falta injustificada (sem desculpa)",
	attendanceTypeOptionUnpaidLeave: "Licença sem vencimento",
	attendanceTypeOptionWork: "Trabalho",
	audio: "Áudio",
	autoDeletion: "Exclusão automática",
	averageDailyHours: "Média de horas diárias",
	avgDaily: "Media diaria",
	avgDailyHours: "Horas diarias medias",
	avgHoursPerWorkingDay: "Horas medias por dia util",
	avgOrderValue: "Valor médio do pedido",
	avgResolutionTime: "Tempo médio de resolução",
	avgResponseTime: "Tempo médio de resposta",
	avgTracksPerPlaylist: "Média de faixas/playlist",
	back: "Voltar",
	bank: "Banco",
	bankAccount: "Conta bancária",
	bankCart: "Cartão bancário",
	bankEmitet: "Banco",
	banner: "Banner",
	baseSalary: "Salário base",
	baseSalaryHourlyLinked: "Atualiza o valor hora a partir da base ÷ horas normais (se horas > 0).",
	basicInformation: "Informações básicas",
	beginningOfAcquaintance: "Início do conhecimento",
	beginningOfContract: "Início do contrato",
	beginningOfTraining: "Início do treinamento",
	benefits: "Benefícios",
	bestSeller: "Mais vendido",
	bestSellers: "Mais vendidos",
	bestSellingItemsByRevenue: "Itens mais vendidos por receita",
	bitrate: "Taxa de bits",
	biweekly: "Quinzenal",
	blogItems: "Itens do blog",
	blogs: "Blogs",
	bonuses: "Bônus",
	bpm: "BPM",
	branch: "Filial da rede elétrica",
	branches: "Lista de sucursais",
	branchesCitiesVillages: "Filiais, Cidades, Aldeias",
	brand: "Marca",
	brands: "Marcas",
	building: "Edifício",
	businessTrip: "Viagem de negócios",
	buttonText: "Texto do botão",
	bypassSteps: "Pular etapas",
	calAddCalendarTooltip: "Criar calendário e partilhar com a equipa",
	calAddEvent: "Adicionar evento",
	calAddReminder: "Adicionar lembrete",
	calAlarm15m: "15 minutos antes",
	calAlarm1d: "1 dia antes",
	calAlarm1h: "1 hora antes",
	calAlarm1w: "1 semana antes",
	calAlarm2d: "2 dias antes",
	calAlarm2h: "2 horas antes",
	calAlarm30m: "30 minutos antes",
	calAlarm5m: "5 minutos antes",
	calAlarmAtEvent: "No horário do evento",
	calAllDay: "Dia inteiro",
	calApiNotConfigured: "A API do calendário não está configurada.",
	calCalendarColorLabel: "Cor do calendário",
	calCalendarCreateFailed: "Não foi possível criar o calendário",
	calCalendarCreated: "Calendário criado",
	calCalendarDeleted: "Calendário excluído",
	calCalendarNameLabel: "Nome do calendário",
	calCalendarNamePh: "ex.: Planeamento da equipa",
	calCalendarNameRequired: "Indique o nome do calendário",
	calCalendarSelect: "Calendário",
	calCalendarUpdateFailed: "Não foi possível atualizar o calendário",
	calCalendarUpdated: "Calendário atualizado",
	calCalendarsLabel: "Calendários:",
	calGoogleCalendarLabel: "Google Agenda:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Reuniões:",
	calCancel: "Cancelar",
	calCheckAll: "Selecionar tudo",
	calColor: "Cor",
	calCreateCalendar: "Criar calendário",
	calDay: "Dia",
	calDayOverviewTitle: "Dia",
	calDefaultCalendarName: "Calendário",
	calDelete: "Excluir",
	calDeleteCalendarHasEvents: "Este calendário tem {count} evento(s). O que deseja fazer com eles?",
	calDeleteCalendarNoEvents: "Esta ação não pode ser desfeita.",
	calDeleteCalendarOnly: "Excluir apenas o calendário",
	calDeleteCalendarTitle: "Excluir calendário?",
	calDeleteCalendarWithEvents: "Excluir com eventos",
	calDeleteEventText: "Esta ação não pode ser desfeita.",
	calDeleteEventTitle: "Excluir evento?",
	calDeleteFailed: "Falha ao excluir",
	calDescription: "Descrição",
	calDescriptionPh: "Descrição opcional",
	calEditCalendarTitle: "Editar calendário",
	calEditCalendarTooltip: "Editar calendário",
	calEditEvent: "Editar evento",
	calEditTooltip: "Editar",
	calEnd: "Fim",
	calEndBeforeStart: "O fim não pode ser antes do início",
	calEndTime: "Hora de término",
	calEvent: "Evento",
	calEventCreated: "Evento criado",
	calEventDeleted: "Evento excluído",
	calEventTitle: "Título",
	calEventTitlePh: "Título do evento",
	calEventUpdated: "Evento atualizado",
	calEventsPlural: "eventos",
	calExportIcs: "Exportar .ics",
	calFailedLoadEvents: "Falha ao carregar eventos",
	calHrBirthdayEvent: "Aniversário",
	calHrBirthdays: "Aniversários",
	calHrContractEnd: "Fim do contrato",
	calHrContractEndEvent: "Fim do contrato",
	calHrContractStart: "Início do contrato",
	calHrContractStartEvent: "Início do contrato",
	calHrIdEvent: "Validade do documento",
	calHrIdExpiry: "Validade do documento",
	calHrPassportEvent: "Validade do passaporte",
	calHrPassportExpiry: "Validade do passaporte",
	calHrPositionReview: "Revisão de cargo",
	calHrPositionReviewEvent: "Revisão de cargo",
	calHrSalaryReview: "Revisão salarial",
	calHrSalaryReviewEvent: "Revisão salarial",
	calImportButton: "Importar",
	calImportEventsTitle: "Importar eventos",
	calImportFoundInFile: "encontrados no arquivo. Selecione um calendário:",
	calImportIcs: "Importar .ics",
	calImportedEventTitle: "Evento importado",
	calItLabel: "TI:",
	calItWarrantyEnd: "Fim da garantia",
	calItWarrantyEndEvent: "Fim da garantia",
	calMonth: "Mês",
	calNewCalendarTitle: "Novo calendário",
	calNewEvent: "Novo evento",
	calNoCalendar: "Sem calendário",
	calNoCalendarUncategorised: "Sem calendário (sem categoria)",
	calNoEventsInIcs: "Nenhum evento no arquivo .ics",
	calNoEventsThisDay: "Nenhum evento neste dia.",
	calNoRemindersThisDay: "Nenhum lembrete neste dia.",
	calDayWeatherMap: "Mapa meteorológico",
	calDayHourlyForecast: "Previsão horária",
	calDayWeatherUnavailable: "Previsão indisponível para esta data",
	calDayEventsSection: "Eventos",
	calDayRemindersSection: "Lembretes",
	calOpenProfile: "Abrir perfil",
	calPeopleLabel: "Pessoas:",
	calReminders: "Lembretes",
	calRemindersLabel: "Lembretes:",
	calAttendanceLabel: "Presença:",
	calSecurityLabel: "Segurança:",
	calSecurityAlerts: "Alertas",
	calSecuritySessions: "Sessões",
	calSecurityTokenExpiry: "Expiração do token",
	calRemindersToggle: "Lembretes ativos",
	calSave: "Salvar",
	calSaveFailed: "Falha ao salvar",
	calShareWithUsers: "Partilhar com utilizadores",
	calShareWithUsersPh: "Pesquisar e selecionar pessoas",
	calStart: "Início",
	calStartEndRequired: "Início e fim obrigatórios",
	calStartTime: "Hora de início",
	calSwalDelete: "Excluir",
	calTaskHigh: "Alto",
	calTaskLow: "Baixo",
	calTaskMedium: "Médio",
	calTaskUrgent: "Urgente",
	calTasksLabel: "Tarefas:",
	calTicketsLabel: "Tickets:",
	calToday: "Hoje",
	calUserFallback: "Usuário",
	calWeek: "Semana",
	calculatePayroll: "Calcular folha",
	calculated: "Calculado",
	calculations: "Cálculos",
	calendarEventType: "Evento do calendário",
	calling: "Chamando",
	cancel: "Cancelar",
	clearText: "Limpar texto",
	cancelAction: "Cancelar ação",
	cancelBack: "Cancelar volta",
	cancelled: "Cancelado",
	cannotBeUndone: "Esta ação não pode ser desfeita.",
	cannotPayOnline: "Não é possível pagar online",
	cart: "Funcionários",
	categories: "Categorias",
	category: "Categoria",
	categoryPerformance: "Desempenho da categoria",
	certificate: "Certificado",
	certificateImages: "Imagens de certificado",
	certificates: "Certificados",
	changedDate: "Data de alteração",
	channel: "Canal",
	channelWritePermissionDescription: "Apenas os administradores do chat podem escrever mensagens",
	channels: "Canais",
	charts: "Gráficos",
	chatActions: "acoes do chat",
	chatActiveLabel: "ativo...",
	chatAddOption: "Adicionar opcao",
	chatAddUsers: "Adicionar usuarios",
	chatAddedToGroupNotification: "Adicionado ao chat em grupo",
	chatAddedYouToGroup: "adicionou voce a",
	chatAudioCall: "chamada de audio",
	chatBulkDeleteFailed: "A exclusao em massa falhou.",
	chatBulkForwardFailed: "O encaminhamento em massa falhou.",
	chatCallMessage: "Mensagem de chamada",
	chatChoosingEmoji: "escolhendo emoji...",
	chatClickMapToChoosePoint: "Clique no mapa para escolher um ponto personalizado.",
	chatCoordinatesUnavailable: "Coordenadas indisponiveis",
	chatCopyCoordinates: "Copiar coordenadas",
	chatCopyCoordinatesFailed: "Falha ao copiar coordenadas.",
	chatCreatePoll: "Criar enquete",
	chatCurrent: "Atual",
	chatCurrentLocation: "Localizacao atual",
	chatDashboard: "Painel de chat",
	chatDeleteFailed: "Falha ao excluir",
	chatDeleteForMeOnly: "Excluir apenas para mim",
	chatDeleteForParticipants: "Excluir tambem para participantes",
	chatDeleteLocation: "Excluir localizacao",
	chatDeleteSelectedMessagesDescription:
		"Esta acao remove as mensagens selecionadas da sua visualizacao de chat. Mensagens que nao podem ser excluidas com suas permissoes atuais serao marcadas como falha.",
	chatDeleteSelectedMessagesTitle: "Excluir mensagens selecionadas",
	chatDeletionPartialWarning:
		"Os resultados da exclusao podem ser parciais se algumas mensagens ja tiverem sido excluidas ou se as verificacoes de permissao falharem.",
	chatDepartmentSaveFailed: "Falha ao atualizar departamento",
	chatDepartmentSaveFailedTryAgain: "Tente atualizar o departamento novamente.",
	chatDeselectAllMessages: "Desmarcar tudo",
	chatDestinationChatsLabel: "Chats de destino",
	chatDestinationChatsPlaceholder: "Selecione um ou mais chats",
	chatDirect: "Chat direto",
	chatDirectChat: "Chat direto",
	chatEditFailed: "Nao foi possivel editar a mensagem",
	chatEditFailedTryAgain: "Tente editar novamente.",
	chatEditMessagePlaceholder: "Editar mensagem...",
	writeMessage: "Digite uma mensagem...",
	chatEditingMessage: "Editando mensagem",
	chatExitSelectionMode: "Sair do modo de selecao",
	chatExpired: "Expirado",
	chatForwardFailed: "Falha ao encaminhar",
	chatForwardSelectedMessagesTitle: "Encaminhar mensagens selecionadas",
	chatForwardableLabel: "encaminhaveis",
	chatGeolocationUnavailable: "A geolocalizacao nao esta disponivel neste navegador.",
	chatGroupChat: "chat em grupo",
	chatGroupInfo: "Informacoes do grupo",
	chatGroupMembers: "Membros do grupo",
	chatGroupSettings: "Configuracoes do grupo",
	chatGroupSettingsDescription: "Defina a imagem do grupo e o departamento de RH vinculado",
	chatID: "ID de chat",
	chatImageUploadFailed: "Falha ao enviar imagem",
	chatImageUploadFailedTryAgain: "Tente enviar uma imagem diferente.",
	chatIncludeLabel: "Incluir",
	chatIsChoosingEmoji: "esta escolhendo emoji...",
	chatIsTyping: "esta digitando...",
	chatLastUpdated: "Ultima atualizacao",
	chatLatitude: "Latitude",
	chatLive: "Ao vivo",
	chatLiveFor: "Ao vivo por",
	chatLiveLocation: "Localizacao ao vivo",
	chatLiveLocationOptInWarning:
		"A localizacao ao vivo requer ativacao explicita e pode ser interrompida a qualquer momento.",
	chatLiveLocationSharingActive: "O compartilhamento de localizacao ao vivo esta ativo",
	chatLoadingLocation: "Carregando localizacao...",
	chatLoadingPoll: "Carregando enquete...",
	chatLongitude: "Longitude",
	chatMessagesCannotBeForwarded:
		"mensagem(ns) nao pode(m) ser encaminhada(s) e sera(ao) ignorada(s).",
	chatMessagesDeleted: "Mensagens excluidas",
	chatMessagesForwarded: "Mensagens encaminhadas",
	chatMoreActions: "Mais acoes",
	chatNoAvailableUsersToAdd: "Todos os usuarios disponiveis ja estao neste grupo.",
	chatNoBackground: "Sem fundo",
	chatNoChatsFound: "Nenhum chat encontrado",
	chatNoMessagesForwarded: "Nenhuma mensagem pode ser encaminhada.",
	chatNoSelectedMessagesDeleted: "Nenhuma mensagem selecionada pode ser excluida.",
	chatOpenDepartmentPage: "Abrir pagina do departamento",
	chatOpenMap: "Abrir mapa",
	chatOptionalAddressLabel: "Rotulo de endereco opcional",
	chatOwnMessagesLabel: "proprias",
	chatPartialDelete: "Exclusao parcial",
	chatPartialForward: "Encaminhamento parcial",
	chatPattern: "Padrao",
	chatPickOnMap: "Escolher no mapa",
	chatPickPointOnMap: "Escolha um ponto no mapa.",
	chatPinnedLocation: "Localizacao fixada",
	chatPollAddAnotherOption: "Adicionar outra opcao",
	chatPollAddOptionFailed: "Falha ao adicionar opcao.",
	chatPollAllowAddingOptions: "Permitir adicionar opcoes",
	chatPollAllowMultipleAnswers: "Permitir multiplas respostas",
	chatPollAllowRevote: "Permitir revoto",
	chatPollAnonymous: "Enquete anonima",
	chatPollAnonymousCannotAddOptions: "Um quiz anonimo nao pode permitir adicionar opcoes.",
	chatPollAtLeastOptions: "Minimo de opcoes necessarias:",
	chatPollAutoClose: "Fechamento automatico",
	chatPollChangeVote: "Alterar voto",
	chatPollChooseCorrectAnswer: "Escolha pelo menos uma resposta correta para o quiz.",
	chatPollCloseDate: "Data de fechamento",
	chatPollCloseDateOrOpenPeriod: "Use data de fechamento ou periodo aberto, nao ambos.",
	chatPollCloseFailed: "Falha ao fechar enquete.",
	chatPollClosePoll: "Fechar enquete",
	chatPollCorrectAnswer: "Resposta correta",
	chatPollCorrectAnswers: "Respostas corretas",
	chatPollCreateFailed: "Falha ao criar enquete.",
	chatPollDeletePoll: "Excluir enquete",
	chatPollDescriptionMax: "A descricao deve ter no maximo",
	chatPollExplanationMax: "A explicacao deve ter no maximo",
	chatPollHideResultsUntilClosed: "Ocultar resultados ate fechar",
	chatPollIncorrectAnswer: "Resposta incorreta",
	chatPollLeaveEmptyKeepOpen: "Deixe vazio para manter a enquete aberta",
	chatPollLeaveEmptyNoTimer: "Deixe vazio para nao usar temporizador",
	chatPollLoadVotersFailed: "Falha ao carregar votantes.",
	chatPollMultipleChoice: "Multipla escolha",
	chatPollNewOption: "Nova opcao",
	chatPollNoVoteYet: "Ainda sem voto",
	chatPollNoVotersForOption: "Nenhum votante encontrado para esta opcao.",
	chatPollOpenPeriod: "Periodo aberto",
	chatPollOptionMax: "A opcao deve ter no maximo",
	chatPollOptionRequired: "A opcao e obrigatoria.",
	chatPollOptionsUnique: "As opcoes devem ser unicas.",
	chatPollPublic: "Publico",
	chatPollQuestionMax: "A pergunta deve ter no maximo",
	chatPollQuestionRequired: "A pergunta e obrigatoria.",
	chatPollQuiz: "Quiz",
	chatPollQuizExplanation: "Explicacao do quiz",
	chatPollRegular: "Regular",
	chatPollResultsHiddenUntilClosed: "Os resultados ficam ocultos ate o fechamento da enquete.",
	chatPollSearchVoters: "Pesquisar votantes",
	chatPollShuffleOptions: "Embaralhar opcoes",
	chatPollSingleChoice: "Escolha unica",
	chatPollSingleChoiceOneCorrect: "Um quiz de escolha unica so pode ter uma resposta correta.",
	chatPollSubmitVoteFailed: "Falha ao enviar seu voto.",
	chatPollViewVoters: "Ver votantes",
	chatPollVoteRecorded: "Voto registrado",
	chatPollVotersLabel: "votantes",
	chatPollVotersTitle: "Votantes da enquete",
	chatPollYouVoted: "Voce votou.",
	chatPollYouVotedCanChange: "Voce votou e pode alterar sua resposta.",
	chatPreviewChronological: "Previa (cronologica)",
	chatProvider: "Provedor",
	chatReadCurrentLocationFailed: "Falha ao ler sua localizacao atual.",
	chatRefreshCurrentLocation: "Atualizar localizacao atual",
	chatRuleAllow: "Sim",
	chatRuleDeny: "Nao",
	chatRuleTimed: "Sim, mas so por tempo limitado",
	chatRuleTimerDescription:
		"Exemplo: defina 1 para permitir a acao apenas durante o primeiro minuto apos o envio.",
	chatRuleTimerMinutes: "Temporizador em minutos",
	chatSearchMessage: "Pesquisar mensagem",
	chatSelectAllMessages: "Selecionar tudo",
	chatSelectDepartment: "Selecione o departamento de RH",
	chatSelectOrLoadLocationFirst: "Selecione ou carregue uma localizacao primeiro.",
	chatSelectRepeatingBackground: "Selecione um fundo repetitivo",
	chatSelectUsersToAdd: "Selecione usuarios para adicionar",
	chatSelectedLabel: "selecionados",
	chatSelectionMode: "Modo de selecao",
	chatSendCurrentLocation: "Enviar localizacao atual",
	chatSendLocationFailed: "Falha ao enviar localizacao.",
	chatSendPinnedLocation: "Enviar localizacao fixada",
	chatSendVenue: "Enviar local",
	chatSentAt: "Enviado",
	chatSettings: "Configuracoes do chat",
	chatSettingsEditRule: "Editar mensagens",
	chatSettingsEditRuleDescription:
		"Escolha se mensagens enviadas podem ser editadas sempre, nunca, ou apenas por tempo limitado.",
	chatSettingsForwardRule: "Encaminhar mensagens",
	chatSettingsForwardRuleDescription:
		"Permita encaminhar sempre, nunca, ou apenas por um tempo limitado apos o envio da mensagem.",
	chatSettingsGlobalPageSubtitle:
		"Configure aqui uma vez as regras dos chats pessoais. So os administradores podem configurar as regras do grupo.",
	chatSettingsGlobalPageTitle: "Configuracoes globais do chat",
	chatSettingsGlobalRulesDescription:
		"Estas regras se aplicam a todos os chats pessoais.",
	chatSettingsGlobalSavedSuccess: "As configuracoes globais do chat foram atualizadas com sucesso",
	chatSettingsCompactMode: "Modo compacto",
	chatSettingsCompactModeDescription:
		"Reduza o espacamento e o tamanho dos avatares para mostrar mais chats na barra lateral.",
	chatSettingsSidebarDescription: "Controle como os chats aparecem na barra lateral esquerda.",
	chatSettingsSidebarTitle: "Barra lateral do chat",
	chatSettingsShowLastMessage: "Mostrar ultima mensagem",
	chatSettingsShowLastMessageDescription:
		"Mostre a pre-visualizacao da ultima mensagem e a respetiva data ou hora na barra lateral.",
	chatSettingsReplyRule: "Responder mensagens",
	chatSettingsReplyRuleDescription:
		"Controle se os membros podem responder sempre, nunca, ou apenas dentro de um periodo apos o envio.",
	chatSettingsResetToGlobal: "Restaurar regras padrao do grupo",
	chatSettingsRulesAdminOnly: "Apenas os administradores do chat podem alterar estas regras.",
	chatSettingsRulesDescription:
		"Defina se os membros podem encaminhar, responder ou editar mensagens, com limite de tempo se necessario.",
	chatSettingsRulesTitle: "Regras do chat",
	chatSettingsSaveFailed: "Nao foi possivel salvar as configuracoes do chat",
	chatSettingsSaveFailedTryAgain: "Tente novamente.",
	chatSettingsUsingCustomRules: "Este grupo usa as regras definidas pelos administradores.",
	chatSettingsUsingGlobalRules: "Este grupo usa as regras padrao.",
	chatShareLocation: "Compartilhar localizacao",
	chatSkipLabel: "Ignorar",
	chatSkippedLabel: "ignorados",
	chatStartCall: "Iniciar chamada",
	chatStartLiveSharing: "Iniciar compartilhamento ao vivo",
	chatStopLiveSharing: "Parar compartilhamento ao vivo",
	chatType: "Tipo de chat",
	chatTypeToSearch: "Digite para pesquisar",
	chatTyping: "digitando...",
	chatUnnamedChat: "Chat sem nome",
	chatUpdatingSharedLocationFor: "Atualizando esta localizacao compartilhada por",
	chatUploadGroupImage: "Enviar imagem do grupo",
	chatUserInfo: "Informacoes do usuario",
	chatUsersSaveFailed: "Falha ao adicionar usuarios",
	chatUsersSaveFailedTryAgain: "Tente adicionar os usuarios selecionados novamente.",
	chatVenue: "Local",
	chatVenueTitle: "Titulo do local",
	chatVideoCall: "chamada de video",
	chatViewReportedMessages: "Ver mensagens reportadas",
	chatWaitingDeviceCoordinates: "Aguardando coordenadas do dispositivo...",
	childcarePayment: "Pagamento de creche",
	chooseBoard: "Selecione Board para ver suas categorias e tarefas",
	cities: "Cidades",
	city: "Cidade",
	clear: "Limpar",
	clearFilters: "Limpar filtros",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Clique no botão abaixo para dar o próximo passo em sua jornada",
	client: "Cliente",
	contactEngagement: "Engajamento do cliente",
	contactGroup: "Grupo de clientes",
	contactGroups: "Grupos de clientes",
	contactPlaylist: "Lista de reprodução do cliente",
	contactProfile: "Perfil do cliente",
	clients: "clientes",
	contactsByGender: "Clientes por gênero",
	contactsByGroup: "Clientes por grupo",
	contactsUsing: "clientes usando",
	contactsWithCarts: "Clientes com carrinhos",
	contactsWithFavorites: "Clientes com favoritos",
	clockInOut: "Entrada / Saída",
	close: "Fechar",
	closeNavigation: "Fechar navegação",
	closeTicket: "Fechar o ticket",
	closed: "Fechado",
	closed_late: "Fechado após o prazo",
	closedDate: "Data de encerramento",
	closedTickets: "Bilhetes fechados",
	cmDashboard: "Painel CM",
	code: "Código",
	coin: "Moeda",
	coinBurnTime: "Tempo de queima de moedas",
	coinCount: "Contagem de moedas",
	color: "Cor",
	comment: "Comentário",
	commentTicket: "Comentário de ticket",
	commissions: "Comissões",
	communicationPreferences: "Preferências de comunicação",
	community: "Comunidade",
	company: "Empresa",
	completed: "Concluído",
	completedDate: "Data de conclusão",
	completedTasks: "Tarefas concluídas",
	completionRate: "taxa de conclusão",
	confirm: "Confirmar",
	confirmAction: "Confirmar ação",
	contactForm: "Formulário de contato",
	contactForms: "Formulários de contato",
	contactType: "Tipo de contato",
	contacts: "Contatos",
	contentByType: "Conteúdo por tipo",
	contentItems: "Itens de conteúdo",
	contentManagementOverview: "Visão geral do sistema de gerenciamento de conteúdo",
	contentOverTime: "Conteúdo criado ao longo do tempo (últimos 30 dias)",
	continue: "Continuar",
	contract: "Contrato",
	contractEndDate: "Data de término do contrato",
	contractStartDate: "Data de início do contrato",
	contractor: "Empreiteiro",
	copy: "Copiar",
	costOfBuildingPart: "Custo da parte de construção",
	costOfBuildingPermit: "Custo do alvará de construção",
	country: "País",
	cpu: "Processador",
	create: "Pedido",
	createBoard: "Criar um novo quadro",
	createChat: "Criar chat",
	createGroupChat: "Criar chat em grupo",
	createGroupSubmit: "Criar",
	addNewCategory: "Adicionar nova categoria",
	createNewCategory: "Criar uma nova categoria",
	created: "Criado",
	createdAt: "Criado em",
	createdBy: "Criado por",
	createdByUser: "Criado pelo usuário",
	critical: "Crítico",
	crmDashboard: "Painel CRM",
	cta1: "Chamada para ação seção 1",
	cta2: "Chamada para ação seção 2",
	cta3: "Chamada para ação seção 3",
	currency: "Moeda",
	currentlyStreaming: "transmitindo atualmente",
	currentlyWorking: "Trabalhando agora",
	custom: "Personalizado",
	customerAcquisition: "Aquisição de clientes",
	customerBaseOverview: "Visão geral da base de clientes",
	customerInsights: "Insights do cliente",
	customerRelationshipOverview: "Visão geral do gerenciamento de relacionamento com clientes",
	dashboard: "Painel",
	dashboardSubtitle: "Subtítulo do painel",
	database: "Banco de dados",
	date: "Data",
	dateOfBirth: "Data de nascimento",
	dates: "Datas",
	datingAttendance: "Comparecimento a encontros",
	dayOff: "Folga",
	meeting: "Reunião",
	dayOffForAllEmployees: "Folga para todos os funcionários",
	dayOffRemoved: "Folga removida",
	dayOffSavedForAllEmployees: "Folga salva para todos os funcionários",
	days: "dias",
	daysLeft: "dias restantes",
	daysOfWeek: "Dias da semana",
	daysWorked: "Dias trabalhados",
	deadLine: "Prazo final",
	deadline: "Prazo",
	debt: "Dívida",
	decline: "Recusar",
	deductions: "Descontos",
	defaultEnergyMax: "Energia máxima padrão",
	defaultEnergyMin: "Energia mínima padrão",
	defaultStream: "Fluxo padrão",
	defaultStreams: "Transmissões padrão",
	defaultStreamsDesc: "transmissões padrão",
	delays: "Atrasos",
	delete: "Apagar",
	deleteForEveryone: "Excluir para todos",
	deletePermanently: "Excluir permanentemente",
	deleteRule: "Excluir regra",
	deleteSelected: "Excluir selecionados",
	delivery: "Entrega",
	deliveryAddress: "Endereço de entrega",
	deliveryMethod: "Método de entrega",
	density: "Densidade",
	department: "Departamento",
	departmentChatsHelp:
		"Associe conversas de grupo e canais a este departamento. Mantém-se sincronizado com o campo de departamento de cada conversa.",
	departmentLinkedChats: "Conversas do departamento",
	departments: "Departamentos",
	desc: "Descrição",
	description: "Descrição",
	designer: "Designer",
	detailedFilters: "Filtros detalhados",
	detailedSteps: "Passos detalhados",
	details: "Detalhes",
	developed: "Desenvolvido",
	developedBy: "Desenvolvido por",
	difference: "Diferença",
	diplomaImages: "Imagens de diploma",
	directMessages: "Mensagens diretas",
	disableSteps: "Desativar etapas",
	disabledSteps: "Etapas desativadas",
	disk: "Disco",
	distributionByPaymentType: "Distribuição por tipo de pagamento",
	domainFacility: "Instalações",
	domainFinance: "Finanças",
	domainHR: "RH",
	domainIT: "IT",
	domainOther: "Outro",
	domainSecurity: "Segurança",
	done: "Feito",
	download: "Baixar",
	downloadAsContact: "Baixar como contato",
	draft: "Rascunho",
	dragToReorder: "Arraste para reordenar",
	dropFilesHere: "Arraste os arquivos aqui",
	dropFilesHereOrClick: "Arraste os arquivos aqui ou clique para adicionar mais",
	dropzoneText: "Arraste imagens aqui ou clique para selecionar arquivos",
	dueDate: "Data de vencimento",
	duration: "Duração",
	ecommerceDashboard: "Painel de controle da venda online",
	edit: "Editar",
	editComment: "Editar comentário",
	editItem: "Editar item",
	editProject: "Editar projeto",
	editRule: "Editar regra",
	edited: "Editado",
	editingRule: "Editar regra",
	email: "E-mail",
	sendEmail: "Enviar e-mail",
	employee: "Funcionário",
	employeesPerDepartment: "Funcionários por departamento",
	employerExpenses: "Despesas do empregador",
	employmentStatus: "Status de emprego",
	emptyTrash: "Limpar a lixeira",
	end: "Fim",
	endDate: "Data de término",
	endDateMustBeLaterThanStartDate: "A data de término deve ser posterior à data de início",
	endDateShort: "Data de término",
	endOfTraining: "Fim do treinamento",
	endTime: "Hora de fim",
	ends: "Termina",
	energyLevel: "Nível de energia",
	energyScheduling: "Planejamento energético",
	enterAmount: "Introduzir quantidade",
	enterFeatureSuffix: "Introduzir sufixo de funcionalidade",
	enterFeatureText: "Introduzir texto de funcionalidade",
	enterGroupName: "Digite o nome do grupo...",
	enterLabel: "Introduzir etiqueta",
	enterPersons: "Introduzir número de pessoas",
	enterRuleName: "Introduzir nome de regra",
	entry: "Entrada",
	error: "Erro",
	errorMessage: "Ocorreu um erro, por favor tente novamente.",
	errorOccurred: "Ocorreu um erro",
	errorPageButton: "Leve-me para casa",
	errorPageHelpText: "Precisa de ajuda? Entre em contato com nossa equipe de suporte",
	errorPageSecondaryButton: "Reportar este problema",
	errorPageSubtitle: "A página que você procura não existe",
	errorPageText:
		"Não se preocupe, isso acontece com os melhores! A página pode ter sido movida, excluída, ou você pode ter digitado uma URL incorreta. Vamos te colocar de volta no caminho certo.",
	errorPageTitle: "Ops! Algo deu errado",
	errorUserNotFound: "Usuário não encontrado",
	estimatedHours: "Horas estimadas",
	eventType: "Tipo de evento",
	exit: "Saída",
	expectedSalary: "Salário esperado",
	expireDate: "Data de validade",
	expired: "Expirado",
	expiresOn: "Vence em",
	expiringIdCards: "Cartões de identificação prestes a expirar",
	expiringPassports: "Passaportes prestes a expirar",
	export: "Exportar",
	exportData: "Exportar dados",
	extraLarge: "Extra grande",
	extraSmall: "Extra pequeno",
	faqQuestions: "Perguntas FAQ",
	favorites: "Favoritos",
	features: "Funcionalidades",
	female: "Feminino",
	fields: "Campos",
	file: "Arquivo",
	fileHasBeenRemoved: "O arquivo foi removido",
	fileMovedToTrash: "O arquivo será movido para a lixeira",
	fileRestored: "Arquivo restaurado",
	fileWillBeMovedToTrash: "O arquivo será movido para a lixeira",
	files: "Arquivos",
	filesRestored: "Arquivos restaurados",
	filesWillBePermanentlyDeleted: "arquivos serão excluídos permanentemente.",
	filter: "Filtro",
	filterBy: "Filtro",
	filters: "Filtros",
	finish: "Concluir",
	fired: "Demitido",
	firstIn: "Primeira entrada",
	firstName: "Primeiro Nome",
	forgotPassword: "Esqueceu sua senha?",
	forward: "Encaminhar",
	forwardMessage: "Encaminhar mensagem",
	forwarded: "Encaminhado",
	forwardedFrom: "Encaminhado de",
	fri: "Sexta-feira",
	from: "De",
	fromAttendanceLogs:
		"Preenchido dos registros de ponto deste empregado e período; você pode ajustar.",
	fromDb: "Da base de dados",
	fromHrSettings: "Configurações de RH",
	gallery: "Galeria",
	genderDistribution: "Distribuição de gênero",
	globalFilter: "Filtro global",
	globalSearchClose: "Fechar",
	globalSearchCmd_goCalendar_desc: "Eventos do calendário",
	globalSearchCmd_goCalendar_label: "Ir para o calendário",
	globalSearchCmd_goChat_desc: "Abrir mensagens",
	globalSearchCmd_goChat_label: "Ir para o chat",
	globalSearchCmd_goCrm_desc: "Gestão de clientes",
	globalSearchCmd_goCrm_label: "Ir para o CRM",
	globalSearchCmd_goFinance_desc: "Módulo financeiro",
	globalSearchCmd_goFinance_label: "Ir para Finanças",
	globalSearchCmd_goHr_desc: "Módulo de RH",
	globalSearchCmd_goHr_label: "Ir para RH",
	globalSearchCmd_goIt_desc: "Equipamento de TI",
	globalSearchCmd_goIt_label: "Ir para TI",
	globalSearchCmd_goProjects_desc: "Base de dados de projetos",
	globalSearchCmd_goProjects_label: "Ir para projetos",
	globalSearchCmd_goRadio_desc: "Música e listas",
	globalSearchCmd_goRadio_label: "Ir para o rádio",
	globalSearchCmd_goTickets_desc: "Sistema de tickets",
	globalSearchCmd_goTickets_label: "Ir para tickets",
	globalSearchCmd_goTodo_desc: "Quadros e tarefas",
	globalSearchCmd_goTodo_label: "Ir para tarefas",
	globalSearchCmd_messageUser_desc: "Abrir chat para enviar",
	globalSearchCmd_messageUser_label: "Mensagem ao utilizador",
	globalSearchCmd_newContact_desc: "Adicionar cliente CRM",
	globalSearchCmd_newClient_label: "Novo cliente",
	globalSearchCmd_newOrder_desc: "Criar encomenda",
	globalSearchCmd_newOrder_label: "Nova encomenda",
	globalSearchCmd_newProject_desc: "Criar projeto",
	globalSearchCmd_newProject_label: "Novo projeto",
	globalSearchCmd_newTask_desc: "Criar tarefa",
	globalSearchCmd_newTask_label: "Nova tarefa",
	globalSearchCmd_newTicket_desc: "Criar ticket",
	globalSearchCmd_newTicket_label: "Novo ticket",
	globalSearchCommandBadge: "Comando",
	globalSearchCommands: "Comandos",
	globalSearchCopied: "Copiado!",
	globalSearchCopyLink: "Copiar ligação",
	globalSearchDirectMessage: "Mensagem direta",
	globalSearchFilterAll: "Tudo",
	globalSearchFilterCalendar: "Calendário",
	globalSearchFilterChats: "Chats",
	globalSearchFilterDevices: "Dispositivos",
	globalSearchFilterEcom: "Comércio eletrónico",
	globalSearchFilterFinance: "Finanças",
	globalSearchFilterPeople: "Pessoas",
	globalSearchFilterProjects: "Projetos",
	globalSearchFilterRadio: "Rádio",
	globalSearchFilterTickets: "Tickets",
	globalSearchFilterTodo: "Tarefas",
	globalSearchHidePreview: "Ocultar pré-visualização",
	globalSearchNavigate: "Navegar",
	globalSearchOpen: "Abrir",
	globalSearchOpenInNewTab: "Abrir num novo separador",
	globalSearchPageBadge: "Página",
	globalSearchPlaceholder:
		"Pesquisar qualquer coisa no APIT (utilizadores, tickets, chats, dispositivos…)",
	globalSearchPreviewAddress: "Morada",
	globalSearchPreviewArtist: "Artista",
	globalSearchPreviewChat: "Chat",
	globalSearchPreviewCompany: "Empresa",
	globalSearchPreviewCreated: "Criado",
	globalSearchPreviewDeviceId: "ID do dispositivo",
	globalSearchPreviewEmail: "E-mail",
	globalSearchPreviewEmployeeNumber: "N.º funcionário",
	globalSearchPreviewEnd: "Fim",
	globalSearchPreviewInfo: "Info",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Local",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Número",
	globalSearchPreviewOrderNumber: "Encomenda n.º",
	globalSearchPreviewPhone: "Telefone",
	globalSearchPreviewSent: "Enviado",
	globalSearchPreviewStart: "Início",
	globalSearchPreviewUsername: "Nome de utilizador",
	globalSearchPreviewVendor: "Fornecedor",
	globalSearchPreviewVersion: "Versão",
	globalSearchRecentSearches: "Pesquisas recentes",
	globalSearchRecentlyOpened: "Abertos recentemente",
	globalSearchSectionArtists: "Artistas",
	globalSearchSectionAttendanceDevices: "Dispositivos de assiduidade",
	globalSearchSectionBrands: "Marcas",
	globalSearchSectionCalendarEvents: "Eventos do calendário",
	globalSearchSectionCameras: "Câmaras",
	globalSearchSectionChats: "Chats",
	globalSearchSectionClientGroups: "Grupos de clientes",
	globalSearchSectionClients: "Clientes",
	globalSearchSectionCpus: "CPUs",
	globalSearchSectionDepartments: "Departamentos",
	globalSearchSectionEcomCategories: "Categorias",
	globalSearchSectionFinanceCardIssuers: "Emissores de cartões",
	globalSearchSectionFinanceCards: "Cartões",
	globalSearchSectionFinanceCategories: "Categorias financeiras",
	globalSearchSectionFinanceTransactions: "Transações",
	globalSearchSectionGpus: "GPUs",
	globalSearchSectionKeyboards: "Teclados",
	globalSearchSectionLaptops: "Notebooks",
	globalSearchSectionMessages: "Mensagens",
	globalSearchSectionMice: "Ratos",
	globalSearchSectionMonitors: "Monitores",
	globalSearchSectionOrders: "Encomendas",
	globalSearchSectionPcs: "PCs",
	globalSearchSectionPlaylists: "Listas de reprodução",
	globalSearchSectionPositions: "Cargos",
	globalSearchSectionPrinters: "Impressoras",
	globalSearchSectionProblems: "Problemas",
	globalSearchSectionProducts: "Produtos",
	globalSearchSectionProjects: "Projetos",
	globalSearchSectionRams: "RAM",
	globalSearchSectionRoms: "Armazenamento",
	globalSearchSectionRooms: "Salas",
	globalSearchSectionRouters: "Roteadores",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "Software",
	globalSearchSectionSwitches: "Comutadores",
	globalSearchSectionTelephones: "Telefones",
	globalSearchSectionTickets: "Tickets",
	globalSearchSectionTodoBoards: "Quadros",
	globalSearchSectionTodoCategories: "Categorias",
	globalSearchSectionTodoTasks: "Tarefas",
	globalSearchSectionTracks: "Faixas",
	globalSearchSectionUsers: "Pessoas",
	globalSearchSectionWarrantyProviders: "Fornecedores de garantia",
	globalSearchSelectPreview: "Selecione um item para pré-visualizar",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Mostrar pré-visualização",
	globalSearchSubtitle: "Pesquisar em todos os módulos",
	globalSearchSuggest1: "Pesquisar tickets atribuídos a mim",
	globalSearchSuggest2: "Encontrar funcionário por e-mail",
	globalSearchSuggest3: "Pesquisar mensagens do chat",
	globalSearchSuggest4: "Encontrar dispositivo por IP",
	globalSearchSuggest5: "Pesquisar cliente por telefone",
	globalSearchSuggest6: "Ir para projetos",
	globalSearchTrySearchingFor: "Experimente pesquisar",
	goBack: "Voltar",
	goToMessage: "Ir para a mensagem",
	goToUserAttendanceTab: "Utilizadores → presenças",
	goToUserAttendanceTabTooltip: "Abrir este colaborador em RH Utilizadores no separador Presenças",
	gpu: "Placa Gráfica",
	grossSalary: "Salário bruto",
	group: "Grupo",
	groupChat: "Chat em grupo",
	groupChatWritePermissionDescription: "Todos no chat podem escrever mensagens",
	groupChats: "Chats em grupo",
	groupName: "Nome do grupo (opcional)",
	healthInsurance: "Plano de saúde",
	healthInsuranceBenefit: "Plano de saúde (benefício)",
	help: "Ajuda",
	hideAllSteps: "Ocultar todos os passos",
	hideHistory: "Ocultar histórico",
	hideProjectDetails: "Ocultar detalhes do projeto",
	hideTableColumnFilters: "Ocultar filtros de colunas",
	hideTimeline: "Ocultar linha do tempo",
	high: "Alto",
	highestSpendingCustomers: "Clientes com maior gasto",
	highlight: "Destacar",
	highlightFeature: "Destacar funcionalidade",
	history: "Histórico",
	historyTable: "Tabela de histórico",
	holiday: "Feriado",
	holidayNonWorking: "Feriado / dia não útil",
	hourlyRate: "Valor hora",
	hourlyRateBaseLinked:
		"Atualiza o salário base a partir do valor hora × horas normais (se horas > 0).",
	hr2025RateReferenceTables: "Tabelas de referência de alíquotas 2025",
	hrAccrualAnnualTotal: "Total anual: {amount} dias",
	hrAccrualCoeffPreview: "Prévia do coeficiente",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} horas trabalhadas → {accrualVacationHours} horas de férias",
	hrAccrualCoeffPreviewLine2:
		"Horas de férias obtidas por hora trabalhada: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"O servidor armazena esta provisão em minutos para que a folha de pagamento e os saldos de férias possam usar valores de dias parciais sem desvios de arredondamento.",
	hrAccrualDaily: "Diário (÷ 365)",
	hrAccrualEachDay: "Por dia: +{amount} dias de férias",
	hrAccrualEachMonthFirst: "A cada dia 1: +{amount} dias de férias",
	hrAccrualFixedYearly: "Dias de férias anuais fixos",
	hrAccrualFixedYearlyDesc:
		"Provisiona um número configurado de dias de férias ao longo do ano usando o calendário diário ou mensal existente.",
	hrAccrualMethod: "Método de provisão",
	hrAccrualMethodDesc: "Como as férias se acumulam",
	hrAccrualModelChoice:
		"Selecione um modelo de provisão ativo. Os dias anuais e o coeficiente de horas trabalhadas são alternativas, não são combinados.",
	hrAccrualMonthly: "Mensal (÷ 12, no dia 1)",
	hrAccrualMonthlyEquivalent: "Equivalente mensal: ~{amount} dias",
	hrAccrualPreview: "Prévia da provisão",
	hrAccrualSuffixMin: "min",
	hrAccrualVacationMinutesEarned: "Minutos de férias obtidos",
	hrAccrualVacationMinutesEarnedDesc:
		"Quantos minutos de férias são provisionados para cada unidade de tempo trabalhado.",
	hrAccrualWorkedHoursModel: "Horas trabalhadas por horas de férias",
	hrAccrualWorkedHoursModelDesc:
		"Provisiona férias a partir do tempo efetivamente trabalhado usando um coeficiente configurável de horas trabalhadas.",
	hrAccrualWorkedMinutesUnit: "Unidade de minutos trabalhados",
	hrAccrualWorkedMinutesUnitDesc:
		"Quantos minutos trabalhados devem gerar uma unidade de provisão.",
	hrArmeniaIncomeTaxCalculator: "Calculadora de IR (Armênia)",
	hrArmeniaTaxRates: "Alíquotas fiscais da Armênia",
	hrCalcSummaryGrossToNet:
		"Com salário registrado de {gross} AMD, você receberá {net} AMD líquidos após descontar {deductions} AMD em impostos e contribuições.",
	hrCalcSummaryNetToGross:
		"Para receber {net} AMD líquidos, o contrato deve indicar bruto de {gross} AMD.",
	hrCalculationBreakdown: "Detalhamento do cálculo",
	hrCalculationDirection: "Direção do cálculo",
	hrDefaultBenefitsDescription:
		"Esses padrões aplicam-se a todos os cálculos de folha salvo substituição por empregado.",
	hrDefaultMonthlyBenefits: "Benefícios mensais padrão (AMD)",
	hrDesiredNetSalaryLabel: "Salário líquido desejado (a receber)",
	hrEmployeePensionLabel: "Previdência do empregado:",
	hrEmployeePensionRate: "Alíquota de previdência do empregado",
	hrEmployeePensionRateDesc: "Obrigatório para nascidos após 1973 (2,5%)",
	hrEmployerPensionRate: "Alíquota de previdência do empregador",
	hrEmployerPensionRateDesc: "Contribuição patronal para previdência (2,5%)",
	hrFailedToSaveSettings: "Falha ao salvar as configurações",
	hrGrossSalaryAMD: "Salário bruto (AMD)",
	hrGrossSalaryDescription: "Informe o valor do contrato de trabalho",
	hrGrossSalaryLabel: "Salário bruto (registrado / contrato)",
	hrGrossSalaryRegistered: "Salário bruto (registrado)",
	hrGrossToNet: "Bruto → Líquido",
	hrHealthInsuranceAges: "Plano de saúde (18–65 anos)",
	hrHealthInsuranceBenefit: "Plano de saúde",
	hrHealthInsuranceBenefitDesc: "Contribuição mensal patronal ao plano de saúde (AMD)",
	hrHealthInsuranceEmployeeColumn: "Empregado",
	hrHealthInsuranceEmployeeShare: "Plano de saúde (parte do empregado)",
	hrHealthInsuranceStateColumn: "Estado",
	hrITSector: "Setor de TI (IR 10%)",
	hrITSectorDesc: "Empregado de empresa de TI licenciada",
	hrIncomeTax: "Imposto de renda",
	hrIncomeTaxLabel: "Imposto de renda:",
	hrIncomeTaxRate: "Alíquota do imposto de renda",
	hrIncomeTaxRateDesc: "Alíquota fixa de 20% na Armênia desde 2020",
	hrLeaveAccrualConfiguration: "Configuração da provisão de férias",
	hrLiveRates: "Alíquotas atuais",
	hrLunchCoverage: "Refeição",
	hrLunchCoverageDesc: "Auxílio refeição mensal (AMD)",
	hrMandatoryHealthInsurance: "Plano de saúde obrigatório (18–65)",
	hrMandatoryHealthInsuranceDesc: "Incluir faixas de plano de saúde de 2025",
	hrMilitaryStampRate: "Alíquota do imposto militar",
	hrMilitaryStampRateDesc: "Deixe 0 se não se aplicar",
	hrMonthlyFee: "Taxa mensal",
	hrNetSalaryDescription: "Informe quanto deseja receber líquido",
	hrNetSalaryLabel: "Salário líquido:",
	hrNetSalaryTakeHome: "Salário líquido (a receber)",
	hrNetToGross: "Líquido → Bruto",
	hrOvertimeRateMultiplier: "Multiplicador de hora extra",
	hrOvertimeRateMultiplierDesc: "ex.: 1,5× = adicional de 50% na hora extra",
	hrOvertimeRules: "Regras de hora extra",
	hrBreakIntervals: "Intervalos de Descanso",
	hrBreakIntervalsDesc:
		"Janelas de horário fixas diárias (ex. almoço) excluídas do tempo de trabalho para todos. É possível adicionar mais de um.",
	hrBreakIntervalsEmpty: "Nenhum intervalo de descanso configurado",
	hrBreakIntervalStart: "Início do intervalo",
	hrBreakIntervalEnd: "Fim do intervalo",
	hrAddBreakInterval: "Adicionar intervalo",
	hrOvertimeThreshold: "Limite de hora extra (horas/dia)",
	hrOvertimeThresholdDesc: "Horas acima disso usam a taxa de hora extra",
	hrPensionMandatory: "Obrigatória / voluntária pré-07/2018 (5%)",
	hrPensionNone: "Não participante (0%)",
	hrPensionPost2018: "Voluntária pós-07/2018 (5%)",
	hrPensionSystem: "Sistema de previdência",
	hrPensionSystemDesc: "Seu status no sistema de previdência financiado",
	hrSettingsPageSubtitle: "Configure folha de pagamento, férias e regras de frequência",
	hrSettingsPageTitle: "Configurações de RH",
	hrSettingsUpdatedSuccessfully: "Configurações de RH atualizadas com sucesso",
	hrSickDaysPerYear: "Dias de licença médica por ano",
	hrSickDaysPerYearDesc: "Dias de licença médica remunerada por ano civil",
	hrSocialPaymentPension: "Pagamento social (previdência)",
	hrSocialTaxRate: "Alíquota do imposto social",
	hrSocialTaxRateDesc: "Atualmente 0% na Armênia (substituído pela previdência)",
	hrStampFee: "Taxa (fundo de seguro militar)",
	hrStampFeeTooltip: "Fundo de seguro militar — taxa fixa escalonada por faixa de bruto",
	hrStandardWorkSchedule: "Horário de trabalho padrão",
	hrStateHealthContribution: "Contribuição estatal à saúde",
	hrStateHealthContributionNote: "adicionada pelo Estado ao seu plano (não descontada do salário).",
	hrSuffixDays: "dias",
	hrSuffixHours: "h",
	hrSuffixTimes: "×",
	hrSummary: "Resumo",
	hrTabDefaultBenefits: "Benefícios padrão",
	hrTabLeaveAccrual: "Provisão de férias",
	hrTabTaxCalculator: "Calculadora de impostos",
	hrTabTaxesArmenia: "Impostos (Armênia)",
	hrTabWorkSchedule: "Horário de trabalho",
	hrTaxPreviewTitle: "Prévia de impostos (sobre 500 000 AMD brutos)",
	hrTaxRatesDescription:
		"As alíquotas aplicam-se ao salário bruto. Informe em percentuais (ex.: 20 = 20%).",
	hrTaxRatesDisclaimer:
		"Alíquotas segundo a legislação armênia 2025–2026. IR: 20% padrão, 10% para empresas de TI licenciadas. Previdência: 5% (obrigatória/voluntária pré-2018) ou 5% fixo (voluntária pós-2018). O adicional de 10% aplica a participantes obrigatórios/pré-2018 acima de 500.000 AMD. Confirme com um contador.",
	hrThresholdWarning: "Aviso de limite",
	hrThresholdWarningText:
		"Seu salário está perto de um limite de faixa (100k / 200k / 500k / 1M AMD). Nesses pontos taxa e plano de saúde sobem de faixa; um pequeno aumento do bruto pode reduzir o líquido. A calculadora sempre mostra o bruto mínimo para o líquido desejado.",
	hrTickets: "Tickets RH",
	hrTotalDeductions: "Total de descontos",
	hrTotalEmployeeDeductionsLabel: "Total de descontos do empregado:",
	hrTransportAllowance: "Auxílio transporte",
	hrTransportAllowanceDesc: "Benefício de transporte mensal (AMD)",
	hrVacationDaysPerYear: "Dias de férias por ano",
	hrVacationDaysPerYearDesc: "Direito anual integral (mínimo na Armênia: 20)",
	hrWorkingDayEnd: "Fim do dia de trabalho",
	hrWorkingDayEndDesc: "Fim esperado do turno. As horas diárias são derivadas do início/fim",
	hrWorkingDayStart: "Início do dia de trabalho",
	hrWorkingDayStartDesc: "Horário esperado de entrada para presença e atrasos",
	hrWeekendDays: "Dias de fim de semana",
	hrWeekendDaysDesc: "Selecione quais dias da semana são fins de semana não úteis",
	hrWorkingDaysPerWeek: "Dias úteis por semana",
	hrWorkingDaysPerWeekDesc: "Seg–Sex = 5, Seg–Sáb = 6",
	hrWorkingHoursPerDay: "Horas de trabalho por dia",
	hrWorkingHoursPerDayDesc: "Horas padrão antes da hora extra",
	href: "Link",
	humanResources: "Recursos Humanos",
	id: "ID",
	idCard: "Cartão de identificação",
	idCardEndDate: "Data de término do cartão de identificação",
	idCardNo: "Nº do cartão de identificação",
	idCardStartDate: "Data de início do cartão de identificação",
	idCart: "Cartão de identificação",
	image: "Imagem",
	immediateSupervisor: "Supervisor imediato",
	importance: "Importância",
	important: "Importante",
	inProgress: "Em andamento",
	inSelectedPeriod: "no período selecionado",
	inStock: "Em estoque",
	in_progress: "Em progresso",
	inactive: "Inativo",
	inactiveTime: "Tempo inativo",
	incident: "Incidente",
	incomeTaxAmount: "Valor do IR",
	incomeTaxRate: "Alíquota de IR (%)",
	incomingCall: "Chamada recebida",
	incomingVideoCall: "Chamada de vídeo recebida",
	incorrectLogin: "Você digitou um nome de usuário ou senha incorretos",
	index: "#",
	inputInArmenian: "Inserir em armênio",
	inputInLatin: "Inserir em latim",
	inputInNumbers: "Entrada em números",
	inputInRussian: "Inserir em russo",
	inputNumber: "Inserir número",
	inputNumbers: "Digite números",
	instagramPosts: "Postagens do Instagram",
	insufficientVacationBalance: "Saldo de férias insuficiente",
	interview1: "Entrevista",
	interview2: "Entrevista",
	interview3: "Treinamento",
	interview4: "Estágio",
	interviewDate: "Data da entrevista",
	interviewTime: "Hora da entrevista",
	introSection: "Seção de introdução",
	invalidDate: "Data de entrega inválida",
	inventorySummary: "Resumo do estoque",
	ip: "IP",
	ipAddress: "Endereço IP",
	isActive: "Ativo",
	isColor: "Cor",
	isPrivateOffice: "É um escritório privado?",
	isPublic: "Público",
	itTickets: "Tickets TI",
	items: "itens",
	justifiedAbsence: "Ausência justificada",
	keyText: "Texto chave",
	keyboards: "Teclados",
	label: "Etiqueta",
	language: "Idioma",
	languagePickerLabel: "Idioma",
	large: "Grande",
	last7Days: "conectados nos últimos 7 dias",
	lastAction: "Última ação",
	lastLogin: "Último login",
	lastName: "Sobrenome",
	lastOut: "Última saída",
	lastPunch: "Ultima marcacao",
	lasts: "Duração",
	latestCustomerOrders: "Últimos pedidos de clientes",
	leader: "Líder",
	attendanceManagersFilter: "Gerentes",
	attendanceLeadersFilter: "Líderes",
	leaveBalance: "Saldo de licenças",
	linkCopied: "Link copiado",
	listeners: "Ouvintes",
	livingAddress: "Endereço de residência",
	loading: "Carregando",
	loanDeductions: "Descontos de empréstimo",
	localCode: "Código local",
	logOut: "Sair",
	login: "Entrar",
	loginButton: "Entrar",
	loginFailed: "Falha no login",
	loginFailedMessage: "Por favor, verifique suas credenciais de login",
	loginSuccess: "Login bem-sucedido",
	loginSuccessMessage: "Você fez login com sucesso",
	loginToStartSession: "Faça login para iniciar uma sessão",
	logout: "Sair",
	low: "Baixo",
	lunchCoverage: "Refeição",
	mac: "MAC",
	macAddress: "Endereço MAC",
	main: "Principal",
	itHierarchyAddLaptop: "Adicionar portátil",
	itHierarchyAttachedPc: "PC associado",
	itHierarchyLaptopsUsingPart: "Portáteis que utilizam esta peça",
	itUsedInOtherPlaces: "Utilizado noutros locais",
	mainInformation: "Informações básicas",
	mainInfo: "Informações principais",
	contactInfo: "Informações de contacto",
	personalInfo: "Informações pessoais",
	workingInfo: "Informações de trabalho",
	probation: "Período de experiência",
	educationInfo: "Informações de formação",
	male: "Masculino",
	manualAdjustments: "Ajustes manuais",
	manualAttendanceEntry: "Entrada manual",
	maps: "Mapas",
	maritalStatus: "Estado civil",
	markAllAsRead: "Marcar tudo como lido",
	markSelectedAsRead: "Marcar selecionados como lidos",
	maternityLeave: "Licença maternidade",
	maxEnergy: "Energia máxima",
	maxFilesReached: "Número máximo de arquivos atingido",
	maxSize: "Tamanho máximo",
	mediaGallery: "Galeria de mídia",
	mediaGalleryDescription: "Descrição da galeria de mídia",
	mediator: "Mediador",
	medium: "Médio",
	members: "Membros",
	menu: "Menu",
	message: "Mensagem",
	messages: "Mensagens",
	messagesByType: "Mensagens por tipo",
	messagesOverTime: "Mensagens ao longo do tempo (Últimos 30 dias)",
	militaryStampAmount: "Valor do imposto militar",
	militaryStampRate: "Alíquota do imposto militar",
	minEnergy: "Energia mínima",
	minute: "minuto",
	minutes: "Minutos",
	missingInterval: "Intervalo ausente",
	mon: "Segunda-feira",
	monitor: "Monitor",
	monitors: "Monitores",
	month: "Mês",
	monthly: "Mensal",
	mood: "Estado de ánimo",
	more: "Adicional",
	moreDetailed: "Mais detalhado",
	moreThan: "Mais de",
	motherProject: "Projeto mãe",
	mounted: "Montado",
	mouses: "Ratos",
	moveToTrash: "Mover para a lixeira",
	movedToTrash: "Movido para a lixeira",
	myActiveSteps: "Meus passos ativos",
	myInvolvement: "Meu envolvimento",
	myProjects: "Meus projetos",
	myRole: "Meu papel",
	mySteps: "Meus passos",
	myTickets: "Meus tickets",
	na: "N/A",
	name: "Nome",
	netCash: "Líquido em dinheiro",
	netOfficial: "Líquido oficial",
	netSalary: "Salário líquido",
	newClients: "Novos clientes",
	newClientsOverTime: "Novos clientes ao longo do tempo (últimos 30 dias)",
	newMessage: "Nova mensagem",
	newProducts: "Novos produtos",
	newProject: "Novo projeto",
	newProjects: "Novos projetos",
	newThisPeriod: "Novo neste período",
	newTicket: "Novo ticket",
	newTicketCreatedBy: "Novo ticket criado por",
	newTracks: "Novas faixas",
	newTracksOverTime: "Novas faixas ao longo do tempo (últimos 30 dias)",
	next: "Próximo",
	nextComposition: "Próxima composição",
	nextStep: "Próximo passo",
	noAccess: "Sem acesso",
	noActiveSteps: "Nenhuma etapa ativa",
	noBoardsFound: "Quadros não encontrados",
	noCategoriesFound: "Categorias não encontradas",
	noCategoryDataAvailable: "Nenhum dado de categoria disponível",
	noContent: "Não há conteúdo",
	noCustomerDataAvailable: "Nenhum dado de cliente disponível",
	noData: "Nenhum dado disponível",
	noDataAvailable: "Nenhum dado disponível",
	noDataAvailableForSelectedPeriod: "Nenhum dado disponível para o período selecionado",
	noDepartment: "Sem departamento",
	noDepartments: "Sem departamentos",
	noDescription: "Descrição não encontrada",
	noEmail: "Sem e-mail",
	noExpiringIdCards: "Nenhum cartão de identificação vencido",
	noExpiringPassports: "Nenhum passaporte vencido",
	noGroup: "Sem grupo",
	noMediaDescription: "Descrição de mídia não encontrada",
	noMediaFound: "Nenhum mídia encontrada",
	noMoreItems: "Nenhum item adicional",
	noName: "Sem nome",
	noNeedStep45: "Não é necessário o Passo 4-5",
	noNotifications: "Sem notificações",
	noOrdersInSelectedPeriod: "Nenhum pedido no período selecionado",
	noOvertimeRecords: "Nenhum registro de horas extras encontrado",
	noPaymentDataAvailable: "Nenhum dado de pagamento disponível",
	noProjectsAssigned: "Nenhum projeto atribuído",
	noProjectsAssignedOrInvolved: "Nenhum projeto atribuído ou envolvido",
	noRecentContacts: "Nenhum cliente recente",
	noRecentContent: "Nenhum conteúdo recente",
	noRecentTickets: "Nenhum bilhete recente",
	noRecentTracks: "Nenhuma faixa recente",
	noRecipientInformation: "Sem informações do destinatário",
	noResponsible: "Sem responsável",
	noResult: "Nenhum resultado encontrado",
	noResults: "Nenhum resultado encontrado",
	noResultsFound: "Nenhum resultado encontrado",
	noRulesAdded: "Regras de planejamento não adicionadas",
	noStatusData: "Nenhum dado de status disponível",
	noSystemDaysOffThisMonth: "Sem folgas globais neste mês",
	noTaskDataAvailable: "Nenhum dado de tarefa disponível",
	noTasksYet: "Nenhuma tarefa",
	noTasksYetDescription: "Nenhuma tarefa",
	noUpcomingBirthdays: "Sem aniversários próximos",
	noUsersFound: "Nenhum usuário encontrado",
	noUsersInDepartment: "Nenhum usuário neste departamento",
	noWorkHourData: "Nenhum dado de horas de trabalho",
	no_priority: "Sem prioridade",
	nonWorking: "Dia não útil",
	none: "Nenhum",
	notAvailable: "Produto não disponível",
	notCorrectLoginCredentials: "Credenciais de login incorretas",
	notLoggedInToday: "Não fez login hoje",
	notPlaced: "Não colocado",
	notPresent: "Ausente",
	notResponded: "Sem resposta",
	notWorking: "Não funciona",
	deviceProblems: "Problemas de dispositivos",
	openTickets: "Chamados abertos",
	note: "Nota",
	nothingFound: "Nada encontrado",
	notifications: "Notificações",
	notificationsBellAria: "Abrir notificações",
	similarTicketNotifications: "Notificações de bilhetes semelhantes",
	number: "Número",
	"office-map": "Mapa do escritório",
	officeMapActivatePlacement: "Ativar posicionamento",
	officeMapAgent: "Agente",
	officeMapAll: "Todos",
	officeMapAttendanceDevice: "Dispositivo de presença",
	officeMapAttendanceDevices: "Presença",
	officeMapCable: "Cabo",
	officeMapCableLinePlaced: "A linha do cabo foi posicionada",
	officeMapCableRemovedFromMap: "O cabo foi removido do mapa",
	officeMapCables: "Cabos",
	officeMapCamera: "Câmera",
	officeMapCameras: "Câmeras",
	officeMapNvr: "NVR",
	officeMapChat: "Chat",
	officeMapChatWasNotCreated: "O chat não foi criado",
	officeMapConnectToCamera: "Conectar à câmera",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Desativar",
	officeMapDeviceDetails: "Detalhes do dispositivo",
	officeMapDeviceId: "ID do dispositivo",
	officeMapDisableDragging: "Desativar arrastar",
	officeMapEnableDragging: "Ativar arrastar",
	officeMapEndDeviceOptional: "Dispositivo final (opcional)",
	officeMapFailedToMoveCable: "Falha ao mover o cabo",
	officeMapFailedToMoveItem: "Falha ao mover o item",
	officeMapFailedToMoveRoomArea: "Falha ao mover a área da sala",
	officeMapFailedToOpenChat: "Falha ao abrir o chat",
	officeMapFailedToPlaceItem: "Falha ao posicionar o item",
	officeMapFailedToPlaceUser: "Falha ao posicionar o usuário",
	officeMapFailedToRemoveCable: "Falha ao remover o cabo",
	officeMapFailedToRemoveItem: "Falha ao remover o item",
	officeMapFailedToRemoveRoomArea: "Falha ao remover a área da sala",
	officeMapFailedToSaveCableLine: "Falha ao salvar a linha do cabo",
	officeMapFailedToSaveRoomArea: "Falha ao salvar a área da sala",
	officeMapFinishArea: "Finalizar área",
	officeMapFinishCable: "Finalizar cabo",
	officeMapForbidden: "Proibido",
	officeMapIp: "IP",
	officeMapItem: "Item",
	officeMapItemPlaced: "Item posicionado",
	officeMapItemRemovedFromMap: "O item foi removido do mapa",
	officeMapLaptop: "Notebook",
	officeMapLaptops: "Notebooks",
	officeMapLayers: "Camadas",
	officeMapLinkedItRoom: "Sala de TI vinculada",
	officeMapLive: "Ao vivo",
	officeMapMac: "MAC",
	officeMapMin: "mín.",
	officeMapMonitors: "Monitores",
	officeMapNetworkCable: "Cabo de rede",
	officeMapNoDevicesInArea: "Não há dispositivos ou usuários posicionados nesta área.",
	officeMapNoPermissionToPlaceItem: "Você não tem permissão para posicionar este item.",
	officeMapNoPermissionToPlaceNetworkCable:
		"Você não tem permissão para posicionar um cabo de rede.",
	officeMapNoPermissionToPlaceRoomArea: "Você não tem permissão para posicionar uma área de sala.",
	officeMapNoPermissionToRemoveItem: "Você não tem permissão para remover este item do mapa.",
	officeMapNoPermissionToRemoveNetworkCable:
		"Você não tem permissão para remover o cabo de rede do mapa.",
	officeMapNoPermissionToRemoveRoomArea:
		"Você não tem permissão para remover a área da sala do mapa.",
	officeMapNotAvailable: "N/D",
	officeMapNotConnected: "Não conectado",
	officeMapPc: "PC",
	officeMapPcs: "PCs",
	officeMapPlacement: "Posicionamento",
	officeMapPleaseSelectItemFirst: "Selecione um item primeiro",
	officeMapPleaseSelectRoomFirst: "Selecione uma sala primeiro",
	officeMapPoints: "Pontos",
	officeMapPorts: "Portas",
	officeMapPrinted: "Impresso",
	officeMapPrinters: "Impressoras",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Remover do mapa",
	officeMapRom: "ROM",
	officeMapRoomArea: "Área da sala",
	officeMapRoomAreaPlaced: "A área da sala foi posicionada",
	officeMapRoomAreaRemovedFromMap: "A área da sala foi removida do mapa",
	officeMapRoomAreas: "Salas",
	officeMapRoomContents: "Conteúdo da sala",
	officeMapRouter: "Roteador",
	officeMapRouters: "Roteadores",
	officeMapSelectItem: "Selecionar item",
	officeMapSelectRoom: "Selecionar sala",
	officeMapSpeed: "Velocidade",
	officeMapStartDeviceOptional: "Dispositivo inicial (opcional)",
	officeMapSwitches: "Switches",
	officeMapTelephone: "Telefone",
	officeMapTelephones: "Telefones",
	officeMapUnknown: "Desconhecido",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "O usuário foi posicionado no mapa",
	officeMapUsers: "Usuários",
	officeMapViewContents: "Ver conteúdo",
	officeMapViewFullDetails: "Ver detalhes completos",
	offline: "Offline",
	offlinePaymentOnly: "Pagamento offline apenas",
	oldProject: "Projeto antigo",
	onSale: "À venda",
	onSecond: "No segundo",
	onTime: "Pontual",
	onTimeRate: "Taxa de pontualidade",
	oneOf: "Um de",
	open: "Abrir",
	openBoard: "Abrir Board",
	openDate: "Data de abertura",
	openInModal: "Abrir em janela modal",
	openInNewTab: "Abrir em uma nova aba",
	openNavigation: "Abrir navegação",
	openedDate: "Data de Abertura",
	optional: "Opcional",
	orClickToSelect: "ou clique para selecionar arquivos",
	order: "Pedido",
	orderNumber: "Número do pedido",
	orders: "Pedidos",
	ordersCart: "Gráfico de pedidos",
	otAfterWork: "Horas extras após o trabalho",
	otBeforeWork: "Horas extras antes do trabalho",
	otherBenefits: "Outros benefícios",
	otherDeductions: "Outros descontos",
	otherInsurance: "Outro seguro",
	outOfStock: "Fora de estoque",
	overdue: "Atrasado",
	overtimeComment: "Comentário horas extras",
	overtimeDays: "Dias com horas extras",
	overtimeHours: "Horas extras",
	overtimeRate: "Taxa de hora extra",
	overtimeSummary: "Resumo de horas extras",
	overtimeTotal: "Total de horas extras",
	overview: "Visão geral",
	owner: "Proprietário",
	ownership: "Propriedade",
	pageNotFound: "Página não encontrada",
	pageNotFoundDescription:
		"Ops! A página que você está procurando não existe ou foi movida. Ela pode ter sido removida, teve seu nome alterado ou está temporariamente indisponível.",
	pages: "Páginas",
	paid: "Pago",
	paidStatus: "Status de pagamento",
	paidTimeOff: "Folga remunerada",
	paidTimeOffDays: "Dias de folga remunerada",
	parent: "Pai",
	parentCategory: "Categoria principal",
	parentDepartment: "Departamento pai",
	parentTask: "Tarefa principal",
	parentType: "Tipo de pai",
	parentUser: "Utilizador pai",
	participant: "Participante",
	passportEndDate: "Data de validade do passaporte",
	passportImages: "Imagens de passaporte",
	passportNo: "Nº do passaporte",
	passportStartDate: "Data de início do passaporte",
	password: "Senha",
	pause: "Pausa",
	paused: "Pausado",
	payDate: "Data de pagamento",
	paymentMethod: "Método de pagamento",
	paymentMethods: "Métodos de pagamento",
	paymentSystem: "Sistema de pagamento",
	payrollBreakdown: "Detalhamento da folha",
	payrollCalcError: "Falha no cálculo da folha.",
	payrollCalcHint:
		"Funcionário e período são obrigatórios. Clique para calcular e salvar os totais da folha.",
	payrollCalcMissingFields: "Selecione funcionário, início e fim do período.",
	payrollCommentsForEmployee: "Comentários para o empregado",
	payrollGeneratedFromAttendance: "Folha gerada a partir da frequência",
	payrollHealthInsurancePremium: "Plano de saúde (prêmio)",
	payrollIndexLabel: "N.º",
	payrollIndexPlaceholder: "Índice",
	payrollInternalNotes: "Notas internas",
	payrollNotesSection: "Notas",
	payrollType: "Tipo de folha",
	payrollUsesHrSettings:
		"Hora extra, alíquotas e benefícios padrão (refeição, transporte, saúde) seguem as configurações de RH (Sistema → Configurações de RH).",
	pc: "Computador",
	pcHealth: "Saúde do PC",
	pcs: "PCs",
	pdf: "PDF",
	penalties: "Penalidades",
	pending: "Pendente",
	pensionAmount: "Valor da previdência",
	pensionRate: "Alíquota de previdência",
	periodEnd: "Data de fim",
	periodStart: "Data de início",
	permInput_calendarEvent_overlayCustomCalendars: "Calendários personalizados (filtros)",
	permInput_calendarEvent_overlayIt: "Calendários de TI (garantia do PC)",
	permInput_calendarEvent_overlayPeople: "Calendários de pessoas (RH)",
	permInput_calendarEvent_overlayReminders: "Camada de lembretes",
	permInput_calendarEvent_overlayTasks: "Tarefas (camadas de prioridade)",
	permInput_calendarEvent_overlayTickets: "Camada de tickets (prazos por dominio)",
	permInput_chat_attachFile: "Anexar arquivos",
	permInput_chat_calling: "Chamadas de áudio",
	permInput_chat_pin: "Fixar mensagens",
	permInput_chat_searchFiles: "Pesquisar em arquivos",
	permInput_chat_searchMessages: "Pesquisar em mensagens",
	permInput_chat_sendMessage: "Enviar mensagens",
	permInput_chat_star: "Favoritar mensagens",
	permInput_chat_videoCalling: "Chamadas de vídeo",
	permModuleCrud_download: "Download do calendário (importar .ics)",
	permModuleCrud_upload: "Upload do calendário (exportar .ics)",
	permanentDelete: "Excluir permanentemente?",
	permission: "Permissão",
	permissions: "Permissões",
	persons: "Pessoas",
	phone: "Telefone",
	photo: "Foto",
	photos: "Fotos",
	pickEmoji: "Escolha um emoji",
	pinnedMessages: "Mensagens fixadas",
	placed: "Colocado",
	placedState: "Status colocado",
	placeholder: "Marcador de posição",
	platformDashboard: "Painel de controle da plataforma",
	platformSpecificSettings: "Configurações específicas da plataforma",
	platforms: "Plataformas",
	audioPlaybackSpeed: "Velocidade de reprodução: {rate}. Clique para alterar.",
	playbackMute: "Silenciar",
	playbackUnmute: "Ativar som",
	playbackVoiceMessage: "Mensagem de voz",
	playbackVideoMessage: "Mensagem de vídeo",
	previewVoiceMessage: "Pré-visualizar mensagem de voz",
	play: "Jogar",
	playStatus: "Status de reprodução",
	playing: "Reproduzindo",
	playingComposition: "Composição em reprodução",
	playingHistory: "Histórico de reprodução",
	playlist: "Lista de reprodução",
	playlistStatistics: "Estatísticas de playlists",
	playlistsWithAds: "playlists com anúncios",
	playlistsWithoutAds: "playlists sem anúncios",
	podcast: "Podcast",
	podcastStreams: "transmissões de podcasts",
	podcasts: "Podcasts",
	ports: "Portos",
	position: "Posição",
	positionReviewDate: "Data de revisão do cargo",
	preDefinedFilters: "Filtros pré-definidos",
	preview: "Visualização",
	previous: "Anterior",
	previousStep: "Passo anterior",
	price: "Preço",
	priceB2b: "Preço corporativo",
	priceBasic: "Preço básico",
	priceGroup1: "Grupo de preços 1",
	priceGroup2: "Grupo de preços 2",
	priceGroup3: "Grupo de preços 3",
	priceLists: "Listas de preços",
	printedCount: "Contagem impressa",
	printer: "Impressora",
	printers: "Impressoras",
	priority: "Prioridade",
	priorityDescription: "Regras de planejamento",
	private: "Privado",
	privateChat: "Chat privado",
	privateChatDescription: "Apenas os usuários selecionados podem ver e entrar neste chat",
	problem: "Problema",
	problemDescription: "Descrição do problema",
	problemGroup: "Grupo de problemas",
	problemGroupSupervisorsPlaceholder:
		"Usuários responsáveis por gerenciar chamados neste grupo de problemas",
	problemGroupSupervisorsTab: "Supervisores",
	processTime: "Tempo de processamento",
	processing: "Processando",
	progress: "Progresso",
	product: "Produto",
	productCare: "Cuidado do produto",
	products: "Produtos",
	productsLinked: "Produtos vinculados",
	project: "Projeto",
	projectChanges: "Alterações do projeto",
	projectDeadline: "Prazo do projeto",
	projectDetails: "Detalhes do projeto",
	projectEndDate: "Data de término do projeto",
	projectID: "ID do projeto",
	projectPartition: "Partição do projeto",
	projectPrice: "Preço do projeto",
	projectPrice2: "Preço do projeto",
	projectStartDate: "Data de início do projeto",
	projectType: "Tipo de projeto",
	projectTypes: "Tipos de projetos",
	projects: "Projetos",
	promoCode: "Código promocional",
	promoCodes: "Códigos promocionais",
	promoCodesAndCertificates: "Códigos promocionais e certificados",
	promotions: "Promoções",
	propertyNumber: "Número do imóvel",
	providing: "Fornecendo",
	punchActivity: "Atividade de ponto",
	pto: "Folga remunerada",
	partial: "Parcial",
	quantity: "Quantidade",
	radioDashboard: "Painel de rádio",
	radioManagementOverview: "Visão geral do gerenciamento de transmissão de rádio",
	radioStatistics: "Estatísticas de rádio",
	raises: "Reajustes",
	ram: "Memória RAM",
	rate: "Taxa",
	rating: "Avaliação",
	readOnly: "Somente leitura",
	readOnlyChatNotice:
		"Este chat e somente leitura para membros. Apenas administradores podem escrever mensagens.",
	readyToGetStarted: "Pronto para começar",
	recalculatePayroll: "Recalcular folha",
	recentClients: "Clientes recentes",
	recentContent: "Conteúdo recente",
	recentMessages: "Mensagens recentes",
	recentOrders: "Pedidos recentes",
	recentTickets: "Bilhetes recentes",
	recentTracks: "Faixas recentes",
	refresh: "Atualizar",
	registeredAddress: "Endereço registrado",
	regularHours: "Horas normais",
	regularHoursHrScheduleHint:
		"Preenchido automaticamente das config. de RH: dias úteis no período × horas por dia. Editável.",
	regularPlaylists: "Playlists regulares",
	relatedList: "Lista relacionada",
	relatedObjects: "Objetos relacionados",
	relatedProducts: "Produtos relacionados",
	relatedTasks: "Tarefas relacionadas",
	relations: "Relações",
	remainingVacation: "Férias restantes",
	remote: "Remoto",
	remoteWorkDays: "Dias de trabalho remoto",
	remove: "Remover",
	removeFromList: "Remover da lista",
	removeItem: "Remover item",
	removed: "Removido",
	reopen: "Reabrir",
	replaceableProduct: "Produto substituível",
	replaceableProducts: "Produtos substituíveis",
	replied: "Respondido",
	reply: "Responder",
	request: "Solicitação",
	requestedForUser: "Solicitado para",
	reset: "Redefinir",
	responseTimeDistribution: "Distribuição do tempo de resposta",
	responsible: "Responsável",
	responsibleAndUsers: "Responsáveis e usuários",
	restoreSelected: "Restaurar selecionados",
	restored: "Restaurado",
	returning: "Recorrente",
	revenue: "Receita",
	revenueOverview: "Visão geral da receita",
	review: "Revisão",
	rightNow: "Agora mesmo",
	role: "Função",
	rom: "Memória ROM",
	room: "Sala",
	routers: "Roteadores",
	rpaPrice: "Preço do trabalho do departamento RPA",
	ruleName: "Nome da regra",
	salary: "Salário",
	salaryReviewDate: "Data de revisão salarial",
	sale: "Venda",
	salePrice: "Preço de venda",
	salesBreakdownByCategory: "Divisão de vendas por categoria",
	salesPerformanceOverTime: "Desempenho de vendas ao longo do tempo",
	sat: "Sábado",
	save: "Salvar",
	saveChanges: "Salvar alterações",
	saveComment: "Salvar comentário",
	saved: "Salvo",
	schedulingDisabled: "Planejamento desativado",
	schedulingEnabled: "Planejamento ativado",
	schedulingRules: "Regras de planejamento",
	search: "Pesquisar",
	searchByNameOrId: "Pesquisar por nome ou ID…",
	searchChat: "Pesquisar chat...",
	searchChatGroups: "Pesquisar grupos de chat...",
	searchConversations: "Pesquisar conversas...",
	searchResults: "Resultados da pesquisa",
	searchUsers: "Pesquisar usuários...",
	secondary: "Secundário",
	seconds: "segundos",
	securityAcknowledge: "Reconhecer",
	securityActions: "Ações",
	securityActiveBadge: "Ativa",
	securityActiveSessions: "Sessões ativas",
	securityActivityStatClicks: "Cliques",
	securityActivityStatKeys: "Teclas",
	securityActivityStatMoves: "Movimentos",
	securityActivityTimeline: "Linha do tempo de atividade",
	securityAdminNotes: "Notas do admin",
	securityAdminNotesDevice: "Notas internas sobre este dispositivo...",
	securityAgentHeartbeat: "Heartbeat do agente",
	securityAlertClipPlural: "clipes de alerta nesta página",
	securityAlertClipSingular: "clipe de alerta nesta página",
	securityAlertCount: "alerta",
	securityAlertCountPlural: "alertas",
	securityAlertDrawerNoMedia:
		"Sem mídia vinculada. O agente precisa do FFmpeg. No Windows PATH ou FFMPEG_PATH. Veja os logs.",
	securityAlertDrawerVideoFailed:
		"Comando de vídeo enviado sem upload. Possível erro do agente — veja os logs.",
	securityAlertDrawerVideoPending:
		"Gravando vídeo; aparecerá em breve. O agente captura e envia agora.",
	securityAlertRecordings: "Gravações de alerta",
	securityAlertRecordingsOnly: "Apenas gravações de alerta",
	securityAlertSt_acknowledged: "reconhecida",
	securityAlertSt_false_positive: "falso positivo",
	securityAlertSt_open: "aberta",
	securityAlertSt_resolved: "resolvida",
	securityAlertsTitle: "Alertas de segurança",
	securityAllDevices: "Todos os dispositivos",
	securityAllEventTypes: "Todos os tipos",
	securityAllRules: "Todas as regras",
	securityAllSeverities: "Todas as gravidades",
	securityAllStatuses: "Todos os status",
	securityAppProcessTracking: "Apps / processos",
	securityAppTracking: "Apps",
	securityAppUsageToday: "Uso de apps hoje (min)",
	securityAssignedUser: "Usuário atribuído",
	securityBadgeAlertText: "ALERTA",
	securityBadgeApp: "app",
	securityBadgeApps: "Apps",
	securityBadgeCapture: "captura",
	securityBadgeFiles: "Arquivos",
	securityBadgeOff: "desligado",
	securityBadgeScr: "cap.",
	securityBadgeScreenshot: "Captura",
	securityBadgeVideo: "Vídeo",
	securityBadgeWeb: "Web",
	securityCapture: "Captura",
	securityCaptureEnabledMaster: "Captura ativada (mestre)",
	securityCaptureEverySeconds: "Capturar a cada (segundos)",
	securityCaptureMasterSwitch: "Captura ativada (chave mestra)",
	securityCaptureModes: "Modos de captura",
	securityCaptureOffAlertBody:
		"Captura desativada no dispositivo; substitui a política. Alertas sem capturas nem vídeo.",
	securityCaptureOffAlertTitle: "Substituição de captura: DESLIGADO",
	securityCaptureRecorded: "Captura registrada",
	securityCaptureWhenOnDesc: "Ligado permite capturas e vídeo; desligar desativa ambos",
	securityChartMinutes: "minutos",
	securityChartVisits: "visitas",
	securityClearFilters: "Limpar filtros",
	securityClickLeft: "E",
	securityClickMiddle: "M",
	securityClickPlain: "clique",
	securityClickRight: "D",
	securityClipWord: "Clipe",
	securityConnectedDevices: "Dispositivos conectados",
	securityCreated: "Criado",
	securityDeleteDevice: "Excluir dispositivo",
	securityDeleteDeviceConfirm: "Tem certeza de que deseja excluir",
	securityDeleteDeviceNote:
		"Isso remove apenas o registro do dispositivo de segurança. O perfil do PC em TI não será afetado.",
	securityDeleteDeviceTitle: "Excluir dispositivo de segurança",
	securityDeleteMedia: "Excluir",
	securityDeletePolicyConfirm: "Excluir esta política?",
	securityDevice: "Dispositivo",
	securityDeviceFallback: "Dispositivo",
	securityDeviceIdLabel: "ID do dispositivo",
	securityDeviceNotFound: "Dispositivo não encontrado",
	securityDeviceSettings: "Configurações",
	securityDeviceSettingsHint: "Substitui a política ativa do dispositivo. Herda se vazio.",
	securityDevicesBreadcrumb: "Dispositivos",
	securityDevicesTitle: "Dispositivos de segurança",
	securityDevicesWithAlerts: "Dispositivos com alertas",
	securityDividerCapture: "Captura",
	securityDividerNotes: "Notas",
	securityDividerTracking: "Rastreamento",
	securityDuration: "Duração",
	securityEg15: "ex. 15",
	securityEg30: "ex. 30",
	securityEg300: "ex. 300",
	securityEg5: "ex. 5",
	securityEg60: "ex. 60",
	securityEnabled: "Ativado",
	securityEnd: "Fim",
	securityEventFlushSeconds: "Descarga de eventos (s)",
	securityEventsCount: "evento",
	securityEventsCountPlural: "eventos",
	securityEvtAppProcess: "App / processo",
	securityEvtAppUsage: "Uso do app",
	securityEvtFileEvent: "Evento de arquivo",
	securityEvtHeartbeat: "Heartbeat",
	securityEvtInputActivity: "Atividade de entrada",
	securityEvtKeystroke: "Tecla",
	securityEvtMouseClick: "Clique do mouse",
	securityEvtSessionEnd: "Fim da sessão",
	securityEvtSessionStart: "Início da sessão",
	securityEvtSystemBoot: "Inicialização do sistema",
	securityEvtSystemShutdown: "Desligamento do sistema",
	securityEvtUsb: "Evento USB",
	securityEvtUserLogin: "Login do usuário",
	securityEvtUserLogout: "Logout do usuário",
	securityEvtWebVisit: "Visita web",
	securityEvtWorkstationLock: "Tela bloqueada",
	securityEvtWorkstationUnlock: "Tela desbloqueada",
	securityFailedLoadOverview: "Falha ao carregar a visão geral de segurança",
	securityFailedSavePolicy: "Falha ao salvar a política",
	securityFalsePositiveBtn: "Falso positivo",
	securityFileEventTracking: "Eventos de arquivo",
	securityFilterByDate: "Filtrar por data",
	securityFilterDateRange: "Filtrar por intervalo de datas",
	securityFilteredSuffix: "(filtrado)",
	securityFps: "FPS",
	securityHostname: "Nome do host",
	securityInputActivityCounts: "Atividade de entrada (contagens)",
	securityInputKeystrokeClickTracking: "Rastreamento de teclas/cliques",
	securityInputModeActivityCountsShort: "Só atividade — contagens",
	securityInputModeActivityOnly: "Somente atividade (contagens)",
	securityInputModeDisabled: "Desativado",
	securityInputModeDisabledShort: "Desativado — sem métricas",
	securityInputModeEventsOnly: "Somente eventos",
	securityInputModeEventsStream: "Só eventos — fluxo bruto",
	securityInputModeFullDetail: "Detalhe completo (teclas + cliques)",
	securityInputModeFullKeystrokes: "Detalhe completo — teclas e cliques",
	securityInputModeShort: "Modo de entrada",
	securityInputTrackingMode: "Modo de rastreamento de entrada",
	securityInternalNotesPlaceholder: "Notas internas...",
	securityKeyCharPrefix: "tecla:",
	securityLastSeen: "Visto por último",
	securityLatestClip: "Último clipe",
	securityLinkedItPc: "PC de TI vinculado:",
	securityLiveLoadingSub: "A ligar ao agente — a pré-visualização do ecrã aparecerá em instantes.",
	securityLiveOfflineHint:
		"Dispositivo offline — a visualização ao vivo exige um agente conectado.",
	securityLivePressStart: "Pressione Iniciar ao vivo para abrir o fluxo.",
	securityLiveScreenAlt: "Tela ao vivo",
	securityLiveStatusLive: "AO VIVO",
	securityLiveStatusStandby: "Em espera",
	securityLiveStreamHint: "Fluxo em meia resolução, até 10 fps. Agente v1.4.0+ com jimp.",
	securityLiveWaitingFrames: "Carregando transmissão ao vivo…",
	securityLoggedInSince: "Conectado desde",
	securityLoggedOutSince: "Último logout",
	securityMediaPrefix: "Mídia",
	securityMediaTitle: "Mídia de segurança",
	securityMiddleClick: "clique do meio",
	securityModuleErrorTitle: "Erro do módulo de segurança",
	securityName: "Nome",
	securityNearbyScreenshots: "Capturas próximas",
	securityNever: "Nunca",
	securityNewMediaBadge: "novo",
	securityNewPolicy: "Nova política",
	securityNoActivityEvents: "Sem eventos de atividade",
	securityNoAlertRecordingsPage: "Sem gravações de alerta nesta página",
	securityNoAlertsForDevice: "Sem alertas para este dispositivo",
	securityNoAlertsFound: "Nenhum alerta",
	securityNoDevicesFound: "Nenhum dispositivo",
	securityNoEventsMatchFilter: "Nenhum evento corresponde",
	securityNoOpenAlerts: "Sem alertas abertas",
	securityNoPoliciesConfigured: "Nenhuma política. Crie uma para começar o monitoramento.",
	securityNoPreview: "Sem pré-visualização",
	securityNoRiskyDevices: "Sem dispositivos arriscados",
	securityNoScreenshotsFound: "Nenhuma captura",
	securityNoScreenshotsYet: "Ainda sem capturas",
	securityNoSessionsFound: "Nenhuma sessão",
	securityNoSessionsRecorded: "Nenhuma sessão registrada",
	securityNoUserSession: "Sem sessão",
	securityNoUserSessionLiveHint:
		"O PC está ligado mas sem usuário ativo. Visualização ao vivo e capturas indisponíveis.",
	securityNoUserSessionTitle: "Nenhum usuário conectado",
	securityNoVideoSegmentsFound: "Nenhum segmento de vídeo",
	securityNoVideosYet: "Ainda sem segmentos de vídeo",
	securityOS: "SO",
	securityOnlineDevices: "Dispositivos online",
	securityOpenAlerts: "Alertas abertas",
	securityOpenPcRecord: "Abrir registro do PC",
	securityOverrideOff: "DESLIGADO",
	securityOverrideOn: "LIGADO",
	securityOverridePrefix: "Substituição:",
	securityOverviewTitle: "Visão geral de segurança",
	securityPageOf: "pág.",
	securityPolActivityTrackingDivider: "Rastreamento de atividade",
	securityPolAfterHoursStart: "Início fora do expediente",
	securityPolAlertClipLength: "Duração do clipe de alerta (s)",
	securityPolAlertScore: "Pontuação do alerta (0–100)",
	securityPolAlertSeverity: "Gravidade do alerta",
	securityPolAlertVideoDivider: "Gravação de vídeo de alerta",
	securityPolAlertVideoInfo:
		"Se uma regra dispara um alerta, o agente grava um clipe da área de trabalho com as configurações abaixo; iguais para todas as regras.",
	securityPolAllowedHoursDivider: "Horas de captura permitidas",
	securityPolBadgeAlert: "Alerta",
	securityPolBlockedApps: "Aplicativos bloqueados",
	securityPolBlockedAppsPh: "ex. telegram, discord, torrent",
	securityPolBlockedDomains: "Domínios bloqueados",
	securityPolBlockedDomainsPh: "ex. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Políticas",
	securityPolBulkThreshold: "Limite de eventos em massa de arquivos (eventos/lote)",
	securityPolBulkThresholdDesc: "Número de eventos destrutivos de arquivos por lote para disparar",
	securityPolCollectInputMetrics: "Coletar métricas de atividade de entrada",
	securityPolCollectInputMetricsDesc: "Apenas contagens de mouse/teclado (sem conteúdo de teclas)",
	securityPolCreateAlert: "Criar alerta",
	securityPolCreateAlertDesc: "Se a regra corresponder, alerta de segurança (vídeo = aba Captura)",
	securityPolDescription: "Descrição",
	securityPolEditPolicy: "Editar política",
	securityPolEnableRule: "Ativar regra",
	securityPolEventsRetention: "Retenção de eventos (dias)",
	securityPolEventsRetentionDesc: "Registros de atividade mais antigos serão removidos",
	securityPolExcludedDomains: "Domínios excluídos",
	securityPolExcludedDomainsPh: "ex. online-banking.com",
	securityPolExcludedProcesses: "Nomes de processo excluídos",
	securityPolExcludedProcessesPh: "ex. 1Password, Bitwarden",
	securityPolInputActivityCounts: "Só atividade — contagens mouse/teclado",
	securityPolInputDisabledNoTrack: "Desativado — sem rastreamento de entrada",
	securityPolInputEventsCount: "Só eventos — apenas contagens de teclas",
	securityPolInputFullDetail: "Detalhe completo — teclas e posições de clique",
	securityPolInputModeLabel: "Modo de rastreamento de entrada",
	securityPolInputTrackingDivider: "Rastreamento de entrada",
	securityPolMaskSensitive: "Mascarar janelas sensíveis (gerenciadores de senha, banco)",
	securityPolMaskSensitiveDesc: "Sem capturas para apps/janelas excluídas",
	securityPolMaxFps: "FPS máx.",
	securityPolMediaRetention: "Retenção de mídia (dias)",
	securityPolMediaRetentionDesc: "Capturas e vídeos mais antigos serão excluídos",
	securityPolNewSecurityPolicy: "Nova política de segurança",
	securityPolNotifyUsersDesc:
		"Os usuários selecionados receberão uma notificação no aplicativo quando qualquer regra desta política acionar um alerta.",
	securityPolNotifyUsersLabel: "Notificar administradores ao acionar a política",
	securityPolNotifyUsersPh: "Buscar usuários para notificar…",
	securityPolPolicyName: "Nome da política",
	securityPolPolicyNamePh: "ex. Política da equipe de desenvolvimento",
	securityPolPriority: "Prioridade",
	securityPolPriorityDesc: "Número maior = avaliado primeiro",
	securityPolRecordVideoOnAlert: "Gravar vídeo em alerta de segurança",
	securityPolRecordVideoOnAlertDesc: "Desligado: alertas sem vídeo",
	securityPolRuleAfterHoursDesc: "Dispara se houver atividade fora do horário definido.",
	securityPolRuleAfterHoursLabel: "Atividade fora do expediente",
	securityPolRuleBlockedAppDesc: "Dispara se o usuário monitorado abrir um app da lista.",
	securityPolRuleBlockedAppLabel: "Aplicativo bloqueado",
	securityPolRuleBlockedDomainDesc: "Dispara se o usuário monitorado visitar um domínio da lista.",
	securityPolRuleBlockedDomainLabel: "Domínio bloqueado",
	securityPolRuleBulkFileDesc:
		"Dispara com muitas exclusões/renomes/movimentações de arquivos em um lote.",
	securityPolRuleBulkFileLabel: "Operações em massa de arquivos",
	securityPolRuleUsbDesc: "Dispara ao conectar USB a um dispositivo monitorado.",
	securityPolRuleUsbLabel: "Armazenamento USB detectado",
	securityPolRulesIntro:
		"As regras definem violação e pontuação. Com «Criar alerta», há alerta de segurança; o vídeo segue a aba Captura para todas.",
	securityPolSavePolicy: "Salvar política",
	securityPolScope: "Escopo",
	securityPolScopeDepartment: "Departamento",
	securityPolScopeDevice: "Dispositivos específicos",
	securityPolScopeGlobal: "Global — aplica a todos os dispositivos",
	securityPolScopeUser: "Usuários específicos",
	securityPolTabCapture: "Captura",
	securityPolTabPrivacy: "Privacidade e exclusões",
	securityPolTabRetention: "Retenção",
	securityPolTabRules: "Regras",
	securityPolTrackApps: "Rastrear aplicativos ativos",
	securityPolTrackFiles: "Rastrear atividade de arquivos",
	securityPolTrackWebsites: "Rastrear visitas ao site",
	securityPolTrackingMaster: "Rastreamento ativado (chave mestra)",
	securityPolTrackingMasterDesc: "Desligado inativa rastreamento de apps, web, arquivos e entrada",
	securityPolVisibleNotice: "Mostrar aviso visível de monitoramento aos funcionários",
	securityPolVisibleNoticeDesc: "Exibe um aviso de que o monitoramento está ativo",
	securityPolWorkDayStart: "Início do dia útil (fim fora do expediente)",
	securityPolWorkingHours: "Horário de trabalho (opcional)",
	securityPolWorkingHoursDesc: "Capturar só nesta janela. Formato HH:MM-HH:MM. Vazio = sempre.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Os selos mostram o que está ativado. Para ligar ou desligar capturas de ecrã, vídeo, aplicações, web ou ficheiros, abra a política (lápis) → separador Captura.",
	securityPoliciesTitle: "Políticas de segurança",
	securityPolicyDefaultBadge: "Padrão da política",
	securityPriority: "Prioridade",
	securityQueued: "Na fila!",
	securityRecentOpenAlerts: "Alertas abertas recentes",
	securityRecentScreenshots: "Capturas recentes",
	securityRecordEverySeconds: "Gravar a cada (segundos)",
	securityRecordVideo30s: "Gravar vídeo (30 s)",
	securityRefresh: "Atualizar",
	securityResolution: "Resolução",
	securityResolutionNotePlaceholder: "Nota de resolução (opcional)",
	securityResolve: "Resolver",
	securityRightClick: "clique direito",
	securityRule: "Regra",
	securityRuleCode_AFTER_HOURS: "Fora do expediente",
	securityRuleCode_BLOCKED_APP: "App bloqueado",
	securityRuleCode_BLOCKED_DOMAIN: "Domínio bloqueado",
	securityRuleCode_BULK_FILE_EVENTS: "Eventos em massa de arquivos",
	securityRuleCode_USB_DETECTED: "USB detectado",
	securitySaveSettings: "Salvar configurações",
	securitySaved: "Salvo",
	securityScope: "Escopo",
	securityScopeType_department: "Departamento",
	securityScopeType_device: "Dispositivo",
	securityScopeType_global: "Global",
	securityScopeType_user: "Usuário",
	securityScreenshotAlt: "Captura",
	securityScreenshotOptionsBlank: "Opções de captura (vazio = padrão da política)",
	securityScreenshots: "Capturas",
	securityScreenshotsCount: "Capturas",
	securityScreenshotsLabel: "Capturas",
	securityScreenshotsToday: "Capturas de tela hoje",
	securitySearch: "Pesquisar",
	securitySearchDevicesPlaceholder: "Pesquisar host, ID, usuário...",
	securitySegmentLengthSeconds: "Duração do segmento (s)",
	securitySelectedCount: "selecionados",
	securitySessionActive: "Ativo",
	securitySessionIdle: "Ocioso",
	securitySessionLocked: "Tela bloqueada",
	securitySessionLockedCaptureHint:
		"Tela bloqueada — capturas e visualização ao vivo indisponíveis.",
	securitySessionLockedLiveHint:
		"O usuário bloqueou a tela. Visualização ao vivo, capturas e gravações estão desativadas.",
	securitySessionLockedSince: "Bloqueado desde",
	securitySessionLockedTitle: "A tela está bloqueada",
	securitySessionNotFound: "Sessão não encontrada",
	securitySessionTimeline: "Linha do tempo da sessão",
	securitySessionWord: "Sessão",
	securitySessionsTitle: "Sessões",
	securitySettingsDrawerTitle: "Configurações",
	securitySettingsOverrideHint:
		"Substituem a política só neste dispositivo. Deixe como está para herdar.",
	securitySev_critical: "crítica",
	securitySev_high: "alta",
	securitySev_low: "baixa",
	securitySev_medium: "média",
	securitySeverity: "Gravidade",
	securityShowAllVideos: "Mostrar todos os vídeos",
	securitySourceEvents: "Eventos de origem",
	securitySpeedSec: "Velocidade (s):",
	securityStart: "Início",
	securityStartLive: "Iniciar ao vivo",
	securityStatOf: "de",
	securityStatus: "Status",
	securityStatus_error: "Erro",
	securityStatus_offline: "Offline",
	securityStatus_online: "Online",
	securityStatus_pending: "Pendente",
	securityStatus_unknown: "desconhecido",
	securityStopLive: "Parar ao vivo",
	securityTabActivity: "Atividade",
	securityTabAlerts: "Alertas",
	securityTabLive: "Ao vivo",
	securityTabScreenshots: "Capturas",
	securityTabSessions: "Sessões",
	securityTabSettings: "Configurações",
	securityTabVideos: "Vídeos",
	securityTakeScreenshot: "Capturar tela",
	securityTitle: "Título",
	securityTooltipAppTrack: "Rastreamento de apps",
	securityTooltipCaptureMaster: "Ligar/desligar captura de tela e mídia (mestre)",
	securityTooltipScreenshot: "Ativar/desativar capturas",
	securityTooltipTrackingMaster: "Chave mestra para rastrear apps, web, arquivos e entrada",
	securityTooltipWebTrack: "Rastreamento de domínios",
	securityTopRiskyDevices: "Dispositivos mais arriscados",
	securityTracking: "Rastreamento",
	securityTrackingEnabledMaster: "Rastreamento ativado (mestre)",
	securityTrackingMasterSwitch: "Rastreamento ativado (mestre)",
	securityTrackingOffAlertBody: "Rastreamento desativado no dispositivo; substitui a política.",
	securityTrackingOffAlertTitle: "Substituição de rastreamento: DESLIGADO",
	securityTrackingWhenOffDesc: "Desligado inativa rastreamento de apps, web, arquivos e entrada",
	securityUnassigned: "Não atribuído",
	securityUnknown: "Desconhecido",
	securityUnknownDevice: "Dispositivo desconhecido",
	securityUsePolicyDefault: "Padrão da política",
	securityUser: "Usuário",
	securityUserLoggedIn: "Sessão ativa",
	securityVideoOffAlertBody:
		"Vídeo desativado no dispositivo. Sem gravações de alerta mesmo se a política permitir.",
	securityVideoOffAlertTitle: "Substituição de vídeo: DESLIGADO",
	securityVideoOptionsBlank: "Opções de vídeo (vazio = política)",
	securityVideoPlayAllHint:
		"Reproduzir tudo do clipe selecionado para segmentos mais antigos; ao fim da página carrega a próxima.",
	securityVideoRecording: "Gravação de vídeo",
	securityVideoSegments: "Segmentos de vídeo",
	securityVideoSegmentsCount: "Segmentos de vídeo",
	securityViewDetail: "Ver detalhe",
	securityWebDomainTracking: "Domínios web",
	securityWebPollSeconds: "Sondagem histórico web (s)",
	securityWebTracking: "Web",
	securityWebsiteVisitsToday: "Visitas ao site hoje",
	securityWhen: "Quando",
	selectAlbum: "Selecionar álbum",
	selectAll: "Selecionar todos",
	selectArtist: "Selecionar artista",
	selectBoard: "Selecionar Board",
	selectCategory: "Selecionar categoria",
	selectChatPartner: "Selecione um parceiro de chat",
	selectClosedDate: "Selecionar data de encerramento",
	selectDate: "Selecionar data",
	selectDays: "Selecionar dias",
	selectDomain: "Selecionar domínio",
	selectEmployee: "Selecionar funcionário",
	selectFiles: "Selecionar arquivos",
	selectGroup: "Selecionar grupo",
	selectOpenedDate: "Selecione a data de abertura",
	selectParentDepartment: "Selecionar departamento pai",
	selectParentUser: "Selecionar utilizador pai",
	selectPeriod: "Selecionar período",
	selectPlatformToManageAndNavigate: "Selecione uma plataforma para gerenciar e navegar",
	selectPlaylist: "Selecionar playlist",
	selectProduct: "Selecione o produto",
	selectSomething: "Selecione algo",
	selectUsers: "Selecionar usuários",
	selectedSteps: "Etapas selecionadas",
	selectedUsers: "Usuários selecionados",
	seleteSelected: "Selecionar selecionados",
	send: "Enviar",
	sent: "Enviado",
	seoDesc: "Descrição SEO",
	servicesAndPrices: "Serviços e preços",
	setCostOfBuildingPermit: "Definir o custo do alvará de construção",
	setDayOff: "Definir folga",
	settings: "Configurações",
	shiftSchedule: "Escala de Turnos",
	showAllSteps: "Mostrar todos os passos",
	showHistory: "Mostrar histórico",
	showProjectDetails: "Mostrar detalhes do projeto",
	showTableColumnFilters: "Mostrar filtros de colunas",
	showTimeline: "Mostrar linha do tempo",
	showing: "Mostrando",
	shuffle: "Aleatório",
	shuffleEnabled: "Embaralhar ativado",
	shuffleOverride: "Regras de planejamento",
	shuffleOverrideDesc: "Regras de planejamento",
	shuffleOverrideValue: "Regras de planejamento",
	sickLeave: "Licença médica",
	sickLeaveDays: "Dias de licença médica",
	signIn: "Entrar",
	signUp: "Cadastrar",
	size: "Tamanho",
	slider: "Controle deslizante",
	small: "Pequeno",
	smb: "Pasta do servidor",
	socialAmount: "Valor do pagamento social",
	socialCardImages: "Imagens de cartão social",
	socialCart: "Cartão social",
	socialNetworkLink: "Link de rede social",
	socialRate: "Taxa de pagamento social",
	software: "Software",
	softwareSkills: "Habilidades de software",
	somethingWentWrong: "Algo deu errado",
	somethingWentWrongInCreatingSteps:
		"Algo deu errado ao criar os passos! Por favor, tente novamente",
	sortBy: "Ordenar por",
	source: "Fonte",
	special: "Especial",
	specialItems: "Itens especiais",
	speed: "Velocidade",
	starred: "Estrelado",
	starredMessages: "Mensagens com estrela",
	start: "Começar",
	startCall: "Iniciar chamada",
	startDate: "Data de início",
	startDateShort: "Data de início",
	startRecording: "Começar a gravar",
	startTime: "Hora de início",
	startVideoCall: "Iniciar chamada de vídeo",
	starts: "Começa",
	state: "Estado",
	states: "Estados",
	status: "Status",
	visibility: "Visibilidade",
	statusUpdate: "Atualização de status",
	stayAnonymous: "Permanecer anônimo",
	step: "Passo",
	stepIsNotStartedYet: "O passo ainda não começou",
	stepStatus: "Status da etapa",
	stepStatusChangedByUser: "O status da etapa foi alterado pelo usuário",
	steps: "Passos",
	stepsLeft: "Passos restantes",
	stillInOffice: "Ainda no escritório",
	stockAndProductOverview: "Visão geral de estoque e produtos",
	stop: "Parar",
	stopRecording: "Parar de gravar",
	stopped: "Parado",
	streamDJ: "DJ de rádio",
	streamStatistics: "Estatísticas de transmissão",
	streaming: "Streaming",
	streamsWithShuffle: "transmissões com embaralhar ativado",
	street: "Rua",
	subDesc: "Subdescrição",
	submit: "Enviar",
	submittedProjects: "Projetos enviados",
	subscription: "Assinatura",
	subscriptions: "Assinaturas",
	substation: "Subestação",
	substationNumber: "Número da subestação",
	subtasks: "Tarefas secundárias",
	subtasksPlaceholder: "Insira cada subtarefa em uma nova linha",
	subtitle: "Subtítulo",
	success: "Sucesso",
	suffix: "Sufixo",
	sun: "Domingo",
	support: "Suporte",
	supportText: "Para todas as perguntas escreva",
	switch: "Interruptor",
	switchers: "Comutadores",
	switches: "Impressoras",
	syncedFromGoogleContacts: "Sincronizado do Google Contatos",
	systemSettings: "Configuração do sistema",
	table: "Tabela",
	tag: "Etiqueta",
	tags: "Tags",
	takeMeHome: "Voltar para casa",
	taskCreatedSuccessfully: "Tarefa criada com sucesso",
	taskCreatedSuccessfullyDescription: "Tarefa criada com sucesso",
	taskDescription: "Descrição da tarefa",
	taskMoved: "Tarefa movida",
	taskMovedDescription: "Tarefa movida para uma nova categoria",
	taskStatusDistribution: "Distribuição do status das tarefas",
	taskTitle: "Título da tarefa",
	tasksAssigned: "Tarefas atribuídas",
	taxCode: "Código fiscal",
	taxNote: "Etiqueta",
	taxes: "Impostos",
	technicalFilesUrl: "URL dos arquivos técnicos",
	telegram: "Telegram",
	text: "Texto",
	theConstructionDepPrice: "O preço do departamento de construção",
	theNumberOfAct: "O número de atos",
	thePriceOfProject: "O preço do projeto",
	themePickerLabel: "Tema",
	thereIsNoResponsible: "Não há responsável",
	thisMonth: "este mês",
	thu: "Quinta-feira",
	ticket: "Bilhete",
	ticketClosed: "Ticket fechado",
	ticketCreateSaveDisabledHint:
		"Escolha o domínio, o grupo de problemas (se houver), o problema e preencha os campos relacionados obrigatórios antes de guardar.",
	ticketDashboard: "Painel de bilhetes",
	ticketDomain: "Domínio",
	ticketHierarchyAddProblem: "Adicionar problema",
	ticketHierarchyAddProblemGroup: "Adicionar grupo",
	ticketHierarchyAddRelatedList: "Adicionar lista relacionada",
	ticketHierarchyAddTicket: "Adicionar chamado",
	ticketHierarchyAddTicketDomain: "Adicionar domínio",
	ticketHierarchyAddTicketHint: "Abre a criação de chamado com este domínio selecionado.",
	ticketHierarchyGroupsInDomain: "Grupos de problemas neste domínio",
	ticketHierarchyNoneYet: "Nenhum ainda — use o botão acima.",
	ticketHierarchyProblemsInGroup: "Problemas neste grupo",
	ticketHierarchyProblemsLinkedToList: "Problemas que usam esta lista",
	ticketSystemOverview: "Visão geral do desempenho e métricas do sistema de bilhetes",
	ticketTitle: "Título",
	ticketType: "Tipo",
	ticketTypeDomainsHint:
		"Deixe vazio para o tipo ficar disponível em todos os domínios. Selecione um ou mais domínios para listá-lo apenas neles.",
	ticketTypeDomainsListAll: "Todos os domínios",
	ticketStatus_sent: "Enviado",
	ticketStatus_in_process: "Em processamento",
	ticketStatus_resolved_rejected: "Rejeitado",
	ticketStatus_resolved_approved: "Aprovado",
	ticketStatus_moved_next: "Movido para o próximo",
	ticketStatus_moved_prev: "Devolvido ao anterior",
	ticketStatus_closed: "Fechado",
	ticketStatus_not_accepted: "Não aceito",
	ticketAction_start: "Iniciar processamento",
	ticketAction_next: "Próximo passo",
	ticketAction_prev: "Passo anterior",
	ticketAction_approve: "Aprovar",
	ticketAction_reject: "Rejeitar",
	ticketAction_close: "Fechar bilhete",
	ticketAction_cancel: "Cancelar ticket",
	ticketAction_comment: "Comentário",
	cancelTicket: "Cancelar ticket",
	ticketCancelReason: "Motivo do cancelamento",
	ticketCancelComment: "Comentário adicional",
	ticketCancelCommentPlaceholder: "Adicione detalhes para quem abriu o ticket, se necessário",
	ticketCancelWarning:
		"Este ticket será marcado como não aceito e fechado. Se o usuário ainda precisar de ajuda, deverá criar um novo ticket.",
	ticketNotAccepted: "Ticket não aceito",
	ticketStepStatus_pending: "Pendente",
	ticketStepStatus_active: "Ativo",
	ticketStepStatus_completed: "Concluído",
	ticketStepStatus_approved: "Aprovado",
	ticketStepStatus_rejected: "Rejeitado",
	ticketStepStatus_closed: "Fechado",
	ticketStepStatus_cancelled: "Cancelado",
	tickets: "Bilhetes",
	ticketsByDepartment: "Bilhetes por departamento",
	ticketsByImportance: "Bilhetes por prioridade",
	ticketsByProblem: "Bilhetes por tipo de problema",
	ticketsByStatus: "Bilhetes por status",
	ticketsOverTime: "Bilhetes ao longo do tempo",
	timAgreement: "Acordo TIM",
	timDelays: "Atrasos do TIM",
	timSentProjects: "Projetos enviados para TIM",
	time: "Hora",
	timeBasedScheduling: "Planejamento baseado no tempo",
	timeOff: "Folga",
	timeRange: "Intervalo de tempo",
	timeToClose: "tempo para fechar o bilhete",
	timeToFirstResponse: "tempo até a primeira resposta",
	timeline: "Linha do tempo",
	timestamp: "Carimbo de data/hora",
	timezone: "Fuso horário",
	title: "Título",
	to: "Para",
	toChat: "Ir para o chat",
	toDo: "A fazer",
	today: "Hoje",
	todaysSales: "Vendas de hoje",
	todo: "Tarefas",
	todoBoard: "Quadro",
	todoBoards: "Quadros",
	todoCategories: "Categorias",
	todoCategory: "Categoria",
	todoLabel: "Label",
	todoLabels: "Etiquetas",
	todoTag: "Etiqueta",
	todoTags: "Etiquetas",
	todoTask: "Tarefa",
	todoTasks: "Tarefas",
	toggles: "Alternadores",
	top: "Top",
	topCustomers: "Principais clientes",
	topProducts: "Principais produtos",
	total: "Total",
	totalActiveTasks: "Total de tarefas ativas",
	totalArtists: "Total de artistas",
	totalChats: "Total de chats",
	totalClients: "Total de clientes",
	totalCoins: "Total de moedas",
	totalContent: "Conteúdo total",
	totalCustomers: "Total de clientes",
	totalDeductions: "Total de descontos",
	totalDuration: "Duração total",
	totalGroups: "grupos totais",
	totalHours: "Total de horas",
	missingDays: "Dias faltantes",
	missingHours: "Horas faltantes",
	scheduled: "Programado",
	totalHoursWorked: "Total de horas trabalhadas",
	totalInTrash: "Total na lixeira",
	totalMessages: "Total de mensagens",
	totalOrders: "Total de pedidos",
	totalOvertime: "Total de horas extras",
	totalPlaylists: "Total de playlists",
	totalPrice: "Preço total",
	totalProducts: "Total de produtos",
	totalRevenue: "Receita total",
	totalTickets: "Total de bilhetes",
	totalTracks: "Total de faixas",
	totalUses: "Total de usos",
	totalValue: "Valor total",
	track: "Faixa",
	trackPlaylist: "Lista de reprodução de faixas",
	tracks: "Faixas",
	tracksByArtist: "Faixas por artista",
	transportAllowance: "Auxílio transporte",
	trash: "Lixeira",
	trashAutoDeleteWarning: "Aviso de eliminação automática da lixeira",
	trashEmptied: "A lixeira foi limpa",
	trashedOn: "Excluido em",
	tryAgain: "Tente novamente",
	tue: "Terça-feira",
	type: "Tipo",
	uncoveredInterval: "Intervalo não coberto",
	undefined: "Indefinido",
	undo: "Desfazer",
	university: "Universidade",
	universityDegree: "Grau universitário",
	universityDepartment: "Departamento universitário",
	unjustifiedAbsence: "Ausência injustificada",
	unknown: "Desconhecido",
	unknownArtist: "Artista desconhecido",
	unnamed: "Sem nome",
	unnamedClient: "Cliente sem nome",
	unnamedTrack: "Faixa sem nome",
	unpaid: "Não remunerado",
	unreadMessages: "Mensagens não lidas",
	unresolvedMissingIntervals: "Intervalos ausentes não resolvidos — a folha pode ser imprecisa",
	upcomingBirthdays: "Aniversários futuros",
	update: "Atualizar",
	updatedAt: "Atualizado em",
	updates: "Atualizações",
	upload: "Enviar",
	uploadDate: "Data de envio",
	uploading: "Carregando",
	uploads: "Carregamentos",
	uptime: "Tempo de atividade",
	urgent: "Urgente",
	used: "Usado",
	usedCount: "Contagem usada",
	usedVacation: "Férias utilizadas",
	user: "Usuário",
	userArchive: "Arquivo do usuário",
	userDashboard: "Painel de controle de usuário",
	userDeleted: "Excluído",
	userEntered: "O usuário entrou",
	userProfile: "Perfil de usuário",
	userPayrollCalcUsesAttendance:
		"Este cálculo usa o resumo canônico de presença e licenças de {monthKey} e, em seguida, aplica as regras fiscais ativas das configurações de RH.",
	userUpdated: "Atualizado",
	userVisited: "O usuário visitou",
	username: "Nome de usuário",
	users: "Recursos humanos",
	vacationBalance: "Saldo de férias",
	vacationDaysForPeriod: "Dias de férias para o período selecionado",
	vacationInterval: "Período de férias",
	vacationPay: "Pagamento de férias",
	value: "Valor",
	version: "Versão",
	viber: "Viber",
	video: "Vídeo",
	view: "Ver",
	viewAll: "Ver todos",
	viewDetails: "Ver detalhes",
	viewMore: "Ver mais",
	viewProject: "Ver projeto",
	viewSteps: "Ver etapas",
	viewTrash: "Ver a lixeira",
	village: "Aldeia",
	villages: "Lista de vilas",
	visitation: "Visitação",
	visitationDeadline: "Prazo de visita",
	visitationDelays: "Atrasos de visita",
	voltage: "Voltagem",
	voltageLevel: "Nível de voltagem",
	volumes: "Volumes",
	voluntaryPensionAmount: "Valor de previdência voluntária",
	voluntaryPensionRate: "Alíquota de previdência voluntária (%)",
	vsPreviousPeriod: "vs período anterior",
	warning: "Aviso",
	warrantyDesc: "Descrição de garantia",
	warrantyEnd: "Fim de garantia",
	warrantyProvider: "Fornecedor de garantia",
	warrantyStart: "Início de garantia",
	watchers: "Observadores",
	weatherAriaYerevanForecast: "Previsão do tempo em Erevan",
	weatherCityYerevan: "Erevan",
	weatherClear: "Limpo",
	weatherCloudy: "Nublado",
	weatherDrizzle: "Chuvisco",
	weatherFog: "Nevoeiro",
	weatherForecastUnavailable: "Previsão indisponível",
	weatherHeadingYerevan: "Tempo em Erevan",
	weatherHumidity: "Umidade",
	weatherLoadingShort: "Tempo",
	weatherNextHours: "Próximas horas",
	weatherPartlyCloudy: "Parcialmente nublado",
	weatherRain: "Chuva",
	weatherSnow: "Neve",
	weatherThunderstorm: "Tempestade",
	weatherUnknown: "Previsão",
	weatherWind: "Vento",
	weatherWindUnit: "km/h",
	wed: "Quarta-feira",
	weekly: "Semanal",
	whatToDo: "O que fazer",
	whatToDoLink: "O que fazer",
	whatsapp: "WhatsApp",
	withAttachments: "Com anexos",
	withCoins: "Com moedas",
	withFavorites: "Com favoritos",
	workDays: "Dias úteis",
	workInformation: "Informações de trabalho",
	workTime: "Tempo de Trabalho",
	workedDays: "Dias trabalhados",
	workedHours: "Horas trabalhadas",
	working: "Trabalhando",
	workingDays: "Dias úteis",
	workingHoursByDay: "Horas de trabalho por dia",
	workingMinutes: "Minutos de trabalho",
	workingState: "Status de trabalho",
	workingStatus: "Status de trabalho",
	write: "Escrever",
	writeUsIfThereAreAnyQuestions: "Escreva para nós se tiver alguma dúvida",
	writingContent: "Conteúdo da redação",
	writingNumber: "Número de redação",
	yes: "Sim",
	yesNextStep: "Sim, vá para o próximo passo",
	yesPreviousStep: "Sim, volte para o passo anterior",
	youWontBeAbleToRevert: "Você não poderá reverter isso!",
	yourFileHasBeenDeleted: "Seu arquivo foi deletado.",
	yourFileHasBeenNotSaved: "Seu arquivo não foi salvo.",
	yourFileHasBeenSaved: "Seu arquivo foi salvo.",
	zipCode: "Código postal",
	zipCodes: "Códigos postais",
	vacationIntervalNoDeduction: "As férias não são descontadas em dias não úteis",
	knowledgeDashboardLoadFailed: "Falha ao carregar o painel",
	knowledgeArticlesLoadFailed: "Falha ao carregar artigos",
	knowledgeBase: "Base de conhecimento",
	knowledgeCreate: "Criar",
	knowledgeRunAutoDocs: "Executar docs automáticas",
	knowledgeTotalArticles: "Total de artigos",
	knowledgePublished: "Publicado",
	knowledgeDrafts: "Rascunhos",
	knowledgeAutoGenerated: "Gerado automaticamente",
	knowledgeLatestUpdatedArticles: "Artigos atualizados recentemente",
	knowledgeArticles: "Artigos",
	knowledgeNewArticle: "Novo artigo",
	knowledgeFilterArticles: "Filtrar artigos",
	knowledgeCategories: "Categorias",
	knowledgeParentCategory: "Categoria pai",
	knowledgeIcon: "Ícone",
	knowledgeColor: "Cor",
	knowledgeSortOrder: "Ordem",
	knowledgeCategorySaved: "Categoria salva",
	knowledgeCategoryDeleted: "Categoria excluída",
	knowledgeSearch: "Pesquisar",
	knowledgeSearchArticles: "Pesquisar artigos",
	knowledgePath: "Caminho",
	knowledgeAutoGeneratedDocs: "Documentos gerados automaticamente",
	knowledgeSingleRoute: "Rota única",
	knowledgeNoScreenshots: "Sem capturas de tela",
	knowledgeGenerateDocumentation: "Gerar documentação",
	knowledgeImportGeneratedDocs: "Importar docs geradas",
	knowledgeDocumentationGenerationStarted: "Geração de documentação iniciada",
	knowledgeImported: "Importado",
	knowledgeGeneratedDocsImported: "{count} documentos gerados importados",
	knowledgeStarted: "Iniciado",
	knowledgeFinished: "Finalizado",
	knowledgeRun: "Execução",
	knowledgeOutput: "Saída",
	knowledgeStatus_draft: "Rascunho",
	knowledgeStatus_published: "Publicado",
	knowledgeStatus_archived: "Arquivado",
	knowledgeVisibility_public: "Público",
	knowledgeVisibility_private: "Privado",
	knowledgeVisibility_company: "Empresa",
	knowledgeRunStatus_idle: "ocioso",
	knowledgeRunStatus_running: "em execução",
	knowledgeRunStatus_completed: "concluído",
	knowledgeRunStatus_failed: "falhou",
	meetings: "Reuniões",
	meetingsListSubtitle: "Salas agendadas com chat APIT e calendário conectados.",
	meetingsCreateMeeting: "Criar reunião",
	meetingsEditMeeting: "Editar reunião",
	meetingsCreateSubtitle: "Reunião = evento de calendário + grupo de chat + sala de vídeo.",
	meetingsMeetingType: "Tipo de reunião",
	meetingsDate: "Data",
	meetingsStartTime: "Hora de início",
	meetingsEndTime: "Hora de término",
	meetingsTimezone: "Fuso horário",
	meetingsVisibility: "Visibilidade",
	meetingsParticipants: "Participantes",
	meetingsGroupsDepartments: "Grupos/departamentos",
	meetingsOptionalGroupIds: "IDs de grupos opcionais",
	meetingsLocation: "Local",
	meetingsReminderTime: "Tempo do lembrete",
	meetingsMinutesShort: "min",
	meetingsAgenda: "Agenda",
	meetingsAgendaPlaceholder: "Início\nRevisão de design\nPróximos passos",
	meetingsRecordingEnabled: "Gravação ativada",
	meetingsAllowJoinBeforeHost: "Permitir entrar antes do anfitrião",
	meetingsMuteUsersOnEntry: "Silenciar usuários ao entrar",
	meetingsAllowScreenSharing: "Permitir compartilhamento de tela",
	meetingsSaveAsDraft: "Salvar como rascunho",
	meetingsSaveMeeting: "Salvar reunião",
	meetingsCreateAndNotifyUsers: "Criar e notificar usuários",
	meetingsSaved: "Reunião salva",
	meetingsSaveFailed: "Não foi possível salvar a reunião",
	meetingsJoin: "Entrar",
	meetingsOpenChat: "Abrir chat",
	meetingsParticipantsCount: "{count} participantes",
	meetingsType_video: "Vídeo",
	meetingsType_audio: "Áudio",
	meetingsType_in_person: "Presencial",
	meetingsType_hybrid: "Híbrida",
	meetingsVisibility_private: "Privada",
	meetingsVisibility_company: "Empresa",
	meetingsVisibility_department: "Departamento",
	meetingsStatus_draft: "Rascunho",
	meetingsStatus_scheduled: "Agendada",
	meetingsStatus_live: "Ao vivo",
	meetingsStatus_ended: "Finalizada",
	meetingsStatus_cancelled: "Cancelada",
	teamWorkload: "Carga de trabalho da equipe",
	workloadTasks: "Tarefas",
	workloadTickets: "Tickets",
	workloadSteps: "Etapas",
	assignedEmployee: "Funcionário atribuído",
	boughtDate: "Data da compra",
	broken: "Quebrado",
	depreciation: "Depreciação",
	deviceStatus: "Status do dispositivo",
	handoverDocument: "Documento de entrega",
	maintenanceSchedule: "Cronograma de manutenção",
	qrCode: "Código QR",
	repair: "Reparo",
	repairHistory: "Histórico de reparos",
	replacementDate: "Data de substituição",
	retired: "Aposentado",
	returnDocument: "Documento de devolução",
	warrantyDate: "Data da garantia",
	noOpenWorkload: "Nenhuma carga de trabalho aberta",
	attendanceTable: "Tabela de frequência",
	filteredFrom: "filtrado de",
	weekend: "Fim de semana",
	late: "Atrasado",
	lateDeparture: "Saída tardia",
	employees: "funcionários",
	exportToExcel: "Exportar para Excel",
	overtime: "Horas extras",
	attendanceNextRefresh: "Próxima atualização",
	refreshAttendanceDevices: "Atualizar dados dos dispositivos de presença",
	attendanceSyncSuccess: "Dispositivos de presença sincronizados",
	attendanceSyncFailed: "Falha ao sincronizar dispositivos de presença",
	// User account security / profile
	contactInformation: "Informações de contacto",
	accountSecurity: "Segurança da conta",
	accountStatus: "Estado da conta",
	accountStatusActive: "Ativa",
	accountStatusLocked: "Bloqueada",
	mustChangePassword: "Deve alterar a palavra-passe",
	lockedAt: "Bloqueada em",
	passwordLastChanged: "Palavra-passe alterada pela última vez",
	accountSecurityDesc: "As palavras-passe atuais nunca são visíveis. Use uma palavra-passe temporária ou um link de redefinição seguro quando as credenciais tiverem de mudar.",
	accountSecurityHint: "Use «Redefinir palavra-passe» quando precisar de uma rotação imediata de credenciais. Use «Enviar link de redefinição» quando o utilizador deve escolher uma nova palavra-passe sem o administrador ver qualquer segredo.",
	lockAccount: "Bloquear conta",
	unlockAccount: "Desbloquear conta",
	forcePasswordChangeAction: "Forçar alteração de palavra-passe",
	clearForcedPasswordChange: "Remover alteração forçada de palavra-passe",
	resetPassword: "Redefinir palavra-passe",
	sendResetLink: "Enviar link de redefinição",
	sessionVisibilityRequiresPermission: "A visibilidade de sessões e dispositivos requer permissão adicional.",
	resetPasswordConfirmTitle: "Redefinir esta palavra-passe?",
	resetPasswordConfirmText: "Será gerada uma palavra-passe temporária e o utilizador terá de a alterar no próximo início de sessão.",
	temporaryPasswordGenerated: "Palavra-passe temporária gerada",
	temporaryPasswordShareHint: "Partilhe isto apenas através de um canal seguro.",
	sendResetLinkConfirmTitle: "Enviar link de redefinição de palavra-passe?",
	sendResetLinkConfirmText: "Será enviado por e-mail um link seguro de utilização única a este utilizador.",
	passwordResetLinkSent: "Link de redefinição de palavra-passe enviado.",
	lockAccountConfirmTitle: "Bloquear esta conta?",
	unlockAccountConfirmTitle: "Desbloquear esta conta?",
	lockAccountConfirmText: "O utilizador não poderá iniciar sessão até ser desbloqueada.",
	unlockAccountConfirmText: "O utilizador poderá iniciar sessão novamente de imediato.",
	accountLockedMsg: "Conta bloqueada.",
	accountUnlockedMsg: "Conta desbloqueada.",
	forcePasswordChangeConfirmTitle: "Forçar alteração de palavra-passe no próximo início de sessão?",
	removeForcedPasswordChangeConfirmTitle: "Remover alteração forçada de palavra-passe?",
	forcePasswordChangeConfirmText: "O utilizador só poderá iniciar sessão para concluir uma alteração de palavra-passe antes de usar a plataforma.",
	removeForcedPasswordChangeConfirmText: "O utilizador poderá continuar a iniciar sessão normalmente.",
	forcedPasswordChangeEnabled: "Alteração forçada de palavra-passe ativada.",
	forcedPasswordChangeRemoved: "Alteração forçada de palavra-passe removida.",
	securityUpdated: "Segurança atualizada",
	securityActionFailed: "Ação de segurança falhou",
	knownDevicesAndSessions: "Dispositivos conhecidos e sessões abertas",
	knownDevicesAndSessionsDesc: "As localizações são aproximadas e normalmente representam uma origem IP, ISP, saída VPN ou gateway do escritório, e não a posição física exata do dispositivo.",
	openSessionsBadge: "{count} abertas",
	revokeOtherSessions: "Revogar outras sessões",
	registeredDevices: "Dispositivos registados",
	unknownDevice: "Dispositivo desconhecido",
	unknownBrowser: "Navegador desconhecido",
	unknownOs: "SO desconhecido",
	browserOnOs: "{browser} em {os}",
	firstSeen: "Visto pela primeira vez",
	sessionsBadge: "{count} sessões",
	currentDevice: "Dispositivo atual",
	noKnownDevices: "Ainda não há dispositivos conhecidos registados.",
	approximateLoginOrigins: "Origens de início de sessão aproximadas",
	sessionDetails: "Detalhes da sessão",
	device: "Dispositivo",
	network: "Rede",
	lastActive: "Última atividade",
	approximateLocationUnavailable: "Localização aproximada indisponível",
	revoke: "Revogar",
	noAuthSessions: "Ainda não há sessões de autenticação registadas.",
	sessionOriginApproximateNote: "Os dados de origem da sessão são aproximados. Não trate a geolocalização IP como a posição exata do dispositivo.",
	connectedMeansNote: "«Ligado» significa que o navegador/app ainda tem um socket ativo. «Desligado» significa que o navegador foi fechado ou ficou offline, mas a sessão guardada pode permanecer válida até terminar sessão, revogar ou expirar.",
	revokeThisSessionTitle: "Revogar esta sessão?",
	revokeThisSessionText: "O dispositivo/sessão selecionado será forçado a iniciar sessão novamente.",
	revokeSession: "Revogar sessão",
	sessionRevoked: "Sessão revogada",
	sessionRevokedSuccess: "A sessão selecionada foi revogada com sucesso.",
	failedToRevokeSession: "Falha ao revogar a sessão",
	unableToRevokeSession: "Não foi possível revogar a sessão selecionada.",
	revokeOtherSessionsTitle: "Revogar outras sessões?",
	revokeOtherSessionsText: "Todas as sessões deste utilizador serão revogadas exceto a sessão atual quando o utilizador revoga os seus próprios dispositivos.",
	revokeSessions: "Revogar sessões",
	sessionsRevoked: "Sessões revogadas",
	revokedSessionsCount: "Revogadas {count} sessões.",
	failedToRevokeSessions: "Falha ao revogar sessões",
	unableToRevokeSessions: "Não foi possível revogar as sessões selecionadas.",
	failedToLoadSessions: "Falha ao carregar sessões",
	unableToLoadUserSessions: "Não foi possível carregar as sessões do utilizador.",
	sessionStatusRevoked: "Revogada",
	sessionStatusConnected: "Ligado",
	sessionStatusDisconnected: "Desligado",
	currentSession: "Atual",
	passwordChangeOnly: "Apenas alteração de palavra-passe",
	faceId: "Face ID",
	passwordsNeverShownHint: "As palavras-passe nunca são mostradas aqui. Use o separador Segurança para bloquear ou desbloquear esta conta, forçar uma alteração de palavra-passe, gerar uma palavra-passe temporária ou enviar um link de redefinição.",
	sharedFolders: "Pastas partilhadas",
	flexId: "Flex Id",
	emailNotProvided: "E-mail não fornecido",
	anonymousUser: "Utilizador anónimo",
	noMapPointsYet: "Ainda não há pontos no mapa",
	noMapPointsYetDesc: "Ainda não há localizações de sessão com coordenadas aproximadas. O backend ainda pode rastrear dispositivos e sessões sem um fornecedor geo.",
	googleMapsKeyNotConfigured: "Chave do Google Maps não configurada",
	googleMapsKeyNotConfiguredDesc: "Defina REACT_APP_GOOGLE_MAPS_API_KEY para apresentar o mapa aproximado de sessões.",
	mapFailedToLoad: "Falha ao carregar o mapa",
	mapFailedToLoadDesc: "Não é possível carregar o Google Maps neste momento.",
	approximateLocation: "Localização aproximada",
	attendanceLastRefreshed: "Última atualização",
	quarter: "Trimestre",
	year: "Ano",
	currentQuarter: "Trimestre atual",
	currentYear: "Ano atual",
	chatClearHistory: "Limpar histórico",
	chatClearHistoryConfirm: "Limpar o histórico deste chat apenas para você?",
	chatDeleteForMe: "Excluir chat",
	chatDeleteForMeConfirm: "Excluir este chat apenas para você? Seu histórico visível será limpo e o chat desaparecerá da sua barra lateral.",
	chatBlockUser: "Bloquear usuário",
	chatUnblockUser: "Desbloquear usuário",
	chatBlockedSection: "Contatos bloqueados",
	chatBlockUserConfirm: "Bloquear este usuário? Ele não poderá enviar mensagens para você neste chat.",
};
